import type { PokemonType } from './types'

export interface WildPokemon {
  nameFr: string
  nameEn: string
  slug: string
  type: PokemonType
  baseHp: number
  baseAtk: number
}

export interface BossTrainer {
  nameFr: string
  nameEn: string
  slug: string
  types?: PokemonType[]
  team: Array<{ nameFr: string; nameEn: string; slug: string; level: number }>
  timerSeconds: number
}

export interface Zone {
  id: number
  nameFr: string
  nameEn: string
  types: PokemonType[]
  wild: WildPokemon[]
  boss: BossTrainer
}

export interface Generation {
  id: number
  nameFr: string
  nameEn: string
  regionFr: string
  regionEn: string
  zones: Zone[]
}

export const GENERATIONS: Generation[] = [
  {
    id: 1,
    nameFr: 'Génération I',
    nameEn: 'Generation I',
    regionFr: 'Kanto',
    regionEn: 'Kanto',
    zones: [
      {
        id: 1,
        nameFr: 'Route 1 — Pierre',
        nameEn: 'Route 1 — Brock',
        types: ['normal', 'bug'],
        wild: [
          { nameFr: 'Rattata', nameEn: 'Rattata', slug: 'rattata', type: 'normal', baseHp: 30, baseAtk: 6 },
          { nameFr: 'Roucool', nameEn: 'Pidgey', slug: 'pidgey', type: 'normal', baseHp: 40, baseAtk: 5 },
          { nameFr: 'Chenipan', nameEn: 'Caterpie', slug: 'caterpie', type: 'bug', baseHp: 25, baseAtk: 3 },
          { nameFr: 'Aspicot', nameEn: 'Weedle', slug: 'weedle', type: 'bug', baseHp: 25, baseAtk: 4 },
          { nameFr: 'Piafabec', nameEn: 'Spearow', slug: 'spearow', type: 'normal', baseHp: 28, baseAtk: 5 },
          { nameFr: 'Nidoran♀', nameEn: 'Nidoran♀', slug: 'nidoranf', type: 'poison', baseHp: 30, baseAtk: 5 },
          { nameFr: 'Nidoran♂', nameEn: 'Nidoran♂', slug: 'nidoranm', type: 'poison', baseHp: 29, baseAtk: 5 },
        ],
        boss: {
          nameFr: 'Pierre',
          nameEn: 'Brock',
          slug: 'brock',
          types: ['rock'],
          team: [
            { nameFr: 'Racaillou', nameEn: 'Geodude', slug: 'geodude', level: 12 },
            { nameFr: 'Onix', nameEn: 'Onix', slug: 'onix', level: 14 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 2,
        nameFr: 'Mont Sélénite — Ondine',
        nameEn: 'Mt. Moon — Misty',
        types: ['poison', 'rock', 'fairy'],
        wild: [
          { nameFr: 'Nosferapti', nameEn: 'Zubat', slug: 'zubat', type: 'poison', baseHp: 40, baseAtk: 5 },
          { nameFr: 'Racaillou', nameEn: 'Geodude', slug: 'geodude', type: 'rock', baseHp: 40, baseAtk: 8 },
          { nameFr: 'Paras', nameEn: 'Paras', slug: 'paras', type: 'bug', baseHp: 35, baseAtk: 7 },
          { nameFr: 'Mélofée', nameEn: 'Clefairy', slug: 'clefairy', type: 'fairy', baseHp: 50, baseAtk: 5 },
          { nameFr: 'Piafabec', nameEn: 'Spearow', slug: 'spearow', type: 'normal', baseHp: 40, baseAtk: 6 },
          { nameFr: 'Nidoran♀', nameEn: 'Nidoran♀', slug: 'nidoranf', type: 'poison', baseHp: 41, baseAtk: 6 },
        ],
        boss: {
          nameFr: 'Ondine',
          nameEn: 'Misty',
          slug: 'misty',
          types: ['water'],
          team: [
            { nameFr: 'Stari', nameEn: 'Staryu', slug: 'staryu', level: 18 },
            { nameFr: 'Staross', nameEn: 'Starmie', slug: 'starmie', level: 21 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 3,
        nameFr: 'Route 24 — Major Bob',
        nameEn: 'Route 24 — Lt. Surge',
        types: ['grass', 'poison', 'fighting'],
        wild: [
          { nameFr: 'Mystherbe', nameEn: 'Oddish', slug: 'oddish', type: 'grass', baseHp: 45, baseAtk: 6 },
          { nameFr: 'Abra', nameEn: 'Abra', slug: 'abra', type: 'psychic', baseHp: 25, baseAtk: 10 },
          { nameFr: 'Abo', nameEn: 'Ekans', slug: 'ekans', type: 'poison', baseHp: 35, baseAtk: 6 },
          { nameFr: 'Férosinge', nameEn: 'Mankey', slug: 'mankey', type: 'fighting', baseHp: 40, baseAtk: 8 },
          { nameFr: 'Miaouss', nameEn: 'Meowth', slug: 'meowth', type: 'normal', baseHp: 35, baseAtk: 7 },
          { nameFr: 'Psykokwak', nameEn: 'Psyduck', slug: 'psyduck', type: 'water', baseHp: 33, baseAtk: 8 },
        ],
        boss: {
          nameFr: 'Major Bob',
          nameEn: 'Lt. Surge',
          slug: 'ltsurge',
          types: ['electric'],
          team: [
            { nameFr: 'Voltorbe', nameEn: 'Voltorb', slug: 'voltorb', level: 21 },
            { nameFr: 'Pikachu', nameEn: 'Pikachu', slug: 'pikachu', level: 18 },
            { nameFr: 'Raichu', nameEn: 'Raichu', slug: 'raichu', level: 24 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 4,
        nameFr: 'Forêt de Jade — Érika',
        nameEn: 'Viridian Forest — Erika',
        types: ['bug', 'grass'],
        wild: [
          { nameFr: 'Insécateur', nameEn: 'Scyther', slug: 'scyther', type: 'bug', baseHp: 50, baseAtk: 11 },
          { nameFr: 'Scarabrute', nameEn: 'Pinsir', slug: 'pinsir', type: 'bug', baseHp: 55, baseAtk: 12 },
          { nameFr: 'Papilusion', nameEn: 'Butterfree', slug: 'butterfree', type: 'bug', baseHp: 45, baseAtk: 5 },
          { nameFr: 'Dardargnan', nameEn: 'Beedrill', slug: 'beedrill', type: 'bug', baseHp: 45, baseAtk: 8 },
          { nameFr: 'Mimitoss', nameEn: 'Venonat', slug: 'venonat', type: 'bug', baseHp: 48, baseAtk: 8 },
          { nameFr: 'Ptitard', nameEn: 'Poliwag', slug: 'poliwag', type: 'water', baseHp: 48, baseAtk: 8 },
          { nameFr: 'Nidoran♂', nameEn: 'Nidoran♂', slug: 'nidoranm', type: 'poison', baseHp: 48, baseAtk: 7 },
        ],
        boss: {
          nameFr: 'Érika',
          nameEn: 'Erika',
          slug: 'erika',
          types: ['grass'],
          team: [
            { nameFr: 'Saquedeneu', nameEn: 'Tangela', slug: 'tangela', level: 29 },
            { nameFr: 'Herbizarre', nameEn: 'Ivysaur', slug: 'ivysaur', level: 29 },
            { nameFr: 'Rafflesia', nameEn: 'Vileplume', slug: 'vileplume', level: 29 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 5,
        nameFr: 'Tour Pokémon — Koga',
        nameEn: 'Pokémon Tower — Koga',
        types: ['ghost', 'poison'],
        wild: [
          { nameFr: 'Fantominus', nameEn: 'Gastly', slug: 'gastly', type: 'ghost', baseHp: 30, baseAtk: 10 },
          { nameFr: 'Spectrum', nameEn: 'Haunter', slug: 'haunter', type: 'ghost', baseHp: 45, baseAtk: 12 },
          { nameFr: 'Osselait', nameEn: 'Cubone', slug: 'cubone', type: 'ground', baseHp: 50, baseAtk: 7 },
          { nameFr: 'Smogo', nameEn: 'Koffing', slug: 'koffing', type: 'poison', baseHp: 40, baseAtk: 7 },
          { nameFr: 'Taupiqueur', nameEn: 'Diglett', slug: 'diglett', type: 'ground', baseHp: 36, baseAtk: 9 },
          { nameFr: 'Sabelette', nameEn: 'Sandshrew', slug: 'sandshrew', type: 'ground', baseHp: 40, baseAtk: 8 },
        ],
        boss: {
          nameFr: 'Koga',
          nameEn: 'Koga',
          slug: 'koga',
          types: ['poison'],
          team: [
            { nameFr: 'Smogo', nameEn: 'Koffing', slug: 'koffing', level: 37 },
            { nameFr: 'Smogogo', nameEn: 'Weezing', slug: 'weezing', level: 39 },
            { nameFr: 'Smogo', nameEn: 'Koffing', slug: 'koffing', level: 37 },
            { nameFr: 'Smogogo', nameEn: 'Weezing', slug: 'weezing', level: 43 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 6,
        nameFr: 'Safrania — Morgane',
        nameEn: 'Seafoam Islands — Sabrina',
        types: ['water', 'ice'],
        wild: [
          { nameFr: 'Tentacool', nameEn: 'Tentacool', slug: 'tentacool', type: 'water', baseHp: 40, baseAtk: 5 },
          { nameFr: 'Kokiyas', nameEn: 'Shellder', slug: 'shellder', type: 'water', baseHp: 30, baseAtk: 7 },
          { nameFr: 'Otaria', nameEn: 'Seel', slug: 'seel', type: 'water', baseHp: 55, baseAtk: 5 },
          { nameFr: 'Stari', nameEn: 'Staryu', slug: 'staryu', type: 'water', baseHp: 30, baseAtk: 7 },
          { nameFr: 'Doduo', nameEn: 'Doduo', slug: 'doduo', type: 'normal', baseHp: 38, baseAtk: 6 },
          { nameFr: 'Goupix', nameEn: 'Vulpix', slug: 'vulpix', type: 'fire', baseHp: 35, baseAtk: 6 },
        ],
        boss: {
          nameFr: 'Morgane',
          nameEn: 'Sabrina',
          slug: 'sabrina',
          types: ['psychic'],
          team: [
            { nameFr: 'Kadabra', nameEn: 'Kadabra', slug: 'kadabra', level: 38 },
            { nameFr: 'M. Mime', nameEn: 'Mr. Mime', slug: 'mrmime', level: 37 },
            { nameFr: 'Hypnomade', nameEn: 'Hypno', slug: 'hypno', level: 38 },
            { nameFr: 'Alakazam', nameEn: 'Alakazam', slug: 'alakazam', level: 43 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 7,
        nameFr: 'Manoir Pokémon — Auguste',
        nameEn: 'Pokémon Mansion — Blaine',
        types: ['fire', 'poison'],
        wild: [
          { nameFr: 'Caninos', nameEn: 'Growlithe', slug: 'growlithe', type: 'fire', baseHp: 55, baseAtk: 7 },
          { nameFr: 'Ponyta', nameEn: 'Ponyta', slug: 'ponyta', type: 'fire', baseHp: 50, baseAtk: 8 },
          { nameFr: 'Tadmorv', nameEn: 'Grimer', slug: 'grimer', type: 'poison', baseHp: 60, baseAtk: 8 },
          { nameFr: 'Magnéti', nameEn: 'Magnemite', slug: 'magnemite', type: 'electric', baseHp: 25, baseAtk: 10 },
          { nameFr: 'Soporifik', nameEn: 'Drowzee', slug: 'drowzee', type: 'psychic', baseHp: 42, baseAtk: 8 },
          { nameFr: 'Rondoudou', nameEn: 'Jigglypuff', slug: 'jigglypuff', type: 'fairy', baseHp: 45, baseAtk: 8 },
          { nameFr: 'Tauros', nameEn: 'Tauros', slug: 'tauros', type: 'normal', baseHp: 46, baseAtk: 8 },
        ],
        boss: {
          nameFr: 'Auguste',
          nameEn: 'Blaine',
          slug: 'blaine',
          types: ['fire'],
          team: [
            { nameFr: 'Caninos', nameEn: 'Growlithe', slug: 'growlithe', level: 42 },
            { nameFr: 'Ponyta', nameEn: 'Ponyta', slug: 'ponyta', level: 40 },
            { nameFr: 'Galopa', nameEn: 'Rapidash', slug: 'rapidash', level: 42 },
            { nameFr: 'Arcanin', nameEn: 'Arcanine', slug: 'arcanine', level: 47 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 8,
        nameFr: 'Route Victoire — Giovanni',
        nameEn: 'Victory Road — Giovanni',
        types: ['fighting', 'rock', 'ground'],
        wild: [
          { nameFr: 'Machopeur', nameEn: 'Machoke', slug: 'machoke', type: 'fighting', baseHp: 70, baseAtk: 10 },
          { nameFr: 'Onix', nameEn: 'Onix', slug: 'onix', type: 'rock', baseHp: 35, baseAtk: 5 },
          { nameFr: 'Ossatueur', nameEn: 'Marowak', slug: 'marowak', type: 'ground', baseHp: 60, baseAtk: 8 },
          { nameFr: 'Grolem', nameEn: 'Golem', slug: 'golem', type: 'rock', baseHp: 70, baseAtk: 11 },
          { nameFr: 'Voltorbe', nameEn: 'Voltorb', slug: 'voltorb', type: 'electric', baseHp: 54, baseAtk: 7 },
          { nameFr: 'Saquedeneu', nameEn: 'Tangela', slug: 'tangela', type: 'grass', baseHp: 54, baseAtk: 7 },
        ],
        boss: {
          nameFr: 'Giovanni',
          nameEn: 'Giovanni',
          slug: 'giovanni',
          types: ['ground'],
          team: [
            { nameFr: 'Rhinocorne', nameEn: 'Rhyhorn', slug: 'rhyhorn', level: 45 },
            { nameFr: 'Nidoqueen', nameEn: 'Nidoqueen', slug: 'nidoqueen', level: 44 },
            { nameFr: 'Nidoking', nameEn: 'Nidoking', slug: 'nidoking', level: 45 },
            { nameFr: 'Rhinoféros', nameEn: 'Rhydon', slug: 'rhydon', level: 50 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 9,
        nameFr: 'Ligue Pokémon — Olga',
        nameEn: 'Pokémon League — Lorelei',
        types: ['ice', 'water'],
        wild: [
          { nameFr: 'Lamantine', nameEn: 'Dewgong', slug: 'dewgong', type: 'water', baseHp: 80, baseAtk: 8 },
          { nameFr: 'Crustabri', nameEn: 'Cloyster', slug: 'cloyster', type: 'ice', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Lokhlass', nameEn: 'Lapras', slug: 'lapras', type: 'water', baseHp: 100, baseAtk: 8 },
          { nameFr: 'Lippoutou', nameEn: 'Jynx', slug: 'jynx', type: 'ice', baseHp: 55, baseAtk: 10 },
          { nameFr: 'Noeunoeuf', nameEn: 'Exeggcute', slug: 'exeggcute', type: 'grass', baseHp: 64, baseAtk: 9 },
          { nameFr: 'Excelangue', nameEn: 'Lickitung', slug: 'lickitung', type: 'normal', baseHp: 66, baseAtk: 9 },
        ],
        boss: {
          nameFr: 'Olga',
          nameEn: 'Lorelei',
          slug: 'lorelei-gen3',
          types: ['ice'],
          team: [
            { nameFr: 'Lamantine', nameEn: 'Dewgong', slug: 'dewgong', level: 52 },
            { nameFr: 'Crustabri', nameEn: 'Cloyster', slug: 'cloyster', level: 51 },
            { nameFr: 'Flagadoss', nameEn: 'Slowbro', slug: 'slowbro', level: 52 },
            { nameFr: 'Lippoutou', nameEn: 'Jynx', slug: 'jynx', level: 54 },
            { nameFr: 'Lokhlass', nameEn: 'Lapras', slug: 'lapras', level: 54 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 10,
        nameFr: 'Ligue Pokémon — Aldo',
        nameEn: 'Pokémon League — Bruno',
        types: ['fighting', 'rock'],
        wild: [
          { nameFr: 'Machopeur', nameEn: 'Machoke', slug: 'machoke', type: 'fighting', baseHp: 70, baseAtk: 10 },
          { nameFr: 'Mackogneur', nameEn: 'Machamp', slug: 'machamp', type: 'fighting', baseHp: 80, baseAtk: 13 },
          { nameFr: 'Onix', nameEn: 'Onix', slug: 'onix', type: 'rock', baseHp: 35, baseAtk: 5 },
          { nameFr: 'Kicklee', nameEn: 'Hitmonlee', slug: 'hitmonlee', type: 'fighting', baseHp: 50, baseAtk: 12 },
          { nameFr: 'Hypotrempe', nameEn: 'Horsea', slug: 'horsea', type: 'water', baseHp: 47, baseAtk: 9 },
          { nameFr: 'Ramoloss', nameEn: 'Slowpoke', slug: 'slowpoke', type: 'psychic', baseHp: 47, baseAtk: 9 },
          { nameFr: 'Kangourex', nameEn: 'Kangaskhan', slug: 'kangaskhan', type: 'normal', baseHp: 52, baseAtk: 10 },
        ],
        boss: {
          nameFr: 'Aldo',
          nameEn: 'Bruno',
          slug: 'bruno',
          types: ['fighting'],
          team: [
            { nameFr: 'Onix', nameEn: 'Onix', slug: 'onix', level: 51 },
            { nameFr: 'Kicklee', nameEn: 'Hitmonlee', slug: 'hitmonlee', level: 53 },
            { nameFr: 'Tygnon', nameEn: 'Hitmonchan', slug: 'hitmonchan', level: 53 },
            { nameFr: 'Onix', nameEn: 'Onix', slug: 'onix', level: 54 },
            { nameFr: 'Mackogneur', nameEn: 'Machamp', slug: 'machamp', level: 56 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 11,
        nameFr: 'Ligue Pokémon — Agatha',
        nameEn: 'Pokémon League — Agatha',
        types: ['ghost', 'poison'],
        wild: [
          { nameFr: 'Ectoplasma', nameEn: 'Gengar', slug: 'gengar', type: 'ghost', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Spectrum', nameEn: 'Haunter', slug: 'haunter', type: 'ghost', baseHp: 45, baseAtk: 12 },
          { nameFr: 'Arbok', nameEn: 'Arbok', slug: 'arbok', type: 'poison', baseHp: 60, baseAtk: 9 },
          { nameFr: 'Nosferalto', nameEn: 'Golbat', slug: 'golbat', type: 'poison', baseHp: 65, baseAtk: 8 },
          { nameFr: 'Poissirène', nameEn: 'Goldeen', slug: 'goldeen', type: 'water', baseHp: 53, baseAtk: 11 },
          { nameFr: 'Krabby', nameEn: 'Krabby', slug: 'krabby', type: 'water', baseHp: 57, baseAtk: 10 },
        ],
        boss: {
          nameFr: 'Agatha',
          nameEn: 'Agatha',
          slug: 'agatha-gen3',
          types: ['ghost'],
          team: [
            { nameFr: 'Ectoplasma', nameEn: 'Gengar', slug: 'gengar', level: 54 },
            { nameFr: 'Nosferalto', nameEn: 'Golbat', slug: 'golbat', level: 54 },
            { nameFr: 'Spectrum', nameEn: 'Haunter', slug: 'haunter', level: 53 },
            { nameFr: 'Arbok', nameEn: 'Arbok', slug: 'arbok', level: 56 },
            { nameFr: 'Ectoplasma', nameEn: 'Gengar', slug: 'gengar', level: 58 },
          ],
          timerSeconds: 35,
        },
      },
      {
        id: 12,
        nameFr: 'Ligue Pokémon — Peter',
        nameEn: 'Pokémon League — Lance',
        types: ['dragon', 'flying'],
        wild: [
          { nameFr: 'Dracolosse', nameEn: 'Dragonite', slug: 'dragonite', type: 'dragon', baseHp: 90, baseAtk: 14 },
          { nameFr: 'Léviator', nameEn: 'Gyarados', slug: 'gyarados', type: 'water', baseHp: 80, baseAtk: 12 },
          { nameFr: 'Ptéra', nameEn: 'Aerodactyl', slug: 'aerodactyl', type: 'rock', baseHp: 70, baseAtk: 10 },
          { nameFr: 'Draco', nameEn: 'Dragonair', slug: 'dragonair', type: 'dragon', baseHp: 60, baseAtk: 8 },
          { nameFr: 'Magicarpe', nameEn: 'Magikarp', slug: 'magikarp', type: 'water', baseHp: 70, baseAtk: 11 },
          { nameFr: 'Pikachu', nameEn: 'Pikachu', slug: 'pikachu', type: 'electric', baseHp: 74, baseAtk: 10 },
        ],
        boss: {
          nameFr: 'Peter',
          nameEn: 'Lance',
          slug: 'lance',
          types: ['dragon'],
          team: [
            { nameFr: 'Léviator', nameEn: 'Gyarados', slug: 'gyarados', level: 56 },
            { nameFr: 'Draco', nameEn: 'Dragonair', slug: 'dragonair', level: 54 },
            { nameFr: 'Draco', nameEn: 'Dragonair', slug: 'dragonair', level: 54 },
            { nameFr: 'Ptéra', nameEn: 'Aerodactyl', slug: 'aerodactyl', level: 58 },
            { nameFr: 'Dracolosse', nameEn: 'Dragonite', slug: 'dragonite', level: 62 },
          ],
          timerSeconds: 40,
        },
      },
      {
        id: 13,
        nameFr: 'Maître — Blue',
        nameEn: 'Champion — Blue',
        types: ['normal', 'water', 'fire'],
        wild: [
          { nameFr: 'Roucarnage', nameEn: 'Pidgeot', slug: 'pidgeot', type: 'normal', baseHp: 80, baseAtk: 8 },
          { nameFr: 'Alakazam', nameEn: 'Alakazam', slug: 'alakazam', type: 'psychic', baseHp: 55, baseAtk: 14 },
          { nameFr: 'Rhinoféros', nameEn: 'Rhydon', slug: 'rhydon', type: 'ground', baseHp: 90, baseAtk: 13 },
          { nameFr: 'Arcanin', nameEn: 'Arcanine', slug: 'arcanine', type: 'fire', baseHp: 80, baseAtk: 11 },
          { nameFr: 'Chétiflor', nameEn: 'Bellsprout', slug: 'bellsprout', type: 'grass', baseHp: 68, baseAtk: 12 },
          { nameFr: 'Canarticho', nameEn: 'Farfetch', slug: 'farfetchd', type: 'normal', baseHp: 68, baseAtk: 11 },
          { nameFr: 'Élektek', nameEn: 'Electabuzz', slug: 'electabuzz', type: 'electric', baseHp: 71, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Blue',
          nameEn: 'Blue',
          slug: 'blue',
          types: ['fire'],
          team: [
            { nameFr: 'Roucarnage', nameEn: 'Pidgeot', slug: 'pidgeot', level: 59 },
            { nameFr: 'Alakazam', nameEn: 'Alakazam', slug: 'alakazam', level: 57 },
            { nameFr: 'Rhinoféros', nameEn: 'Rhydon', slug: 'rhydon', level: 59 },
            { nameFr: 'Noadkoko', nameEn: 'Exeggutor', slug: 'exeggutor', level: 61 },
            { nameFr: 'Léviator', nameEn: 'Gyarados', slug: 'gyarados', level: 61 },
            { nameFr: 'Dracaufeu', nameEn: 'Charizard', slug: 'charizard', level: 65 },
          ],
          timerSeconds: 45,
        },
      },
    ],
  },
  {
    id: 2,
    nameFr: 'Génération II',
    nameEn: 'Generation II',
    regionFr: 'Johto',
    regionEn: 'Johto',
    zones: [
      {
        id: 1,
        nameFr: 'Route 30 — Albert',
        nameEn: 'Route 30 — Falkner',
        types: ['normal', 'flying'],
        wild: [
          { nameFr: 'Fouinette', nameEn: 'Sentret', slug: 'sentret', type: 'normal', baseHp: 35, baseAtk: 5 },
          { nameFr: 'Hoothoot', nameEn: 'Hoothoot', slug: 'hoothoot', type: 'flying', baseHp: 40, baseAtk: 5 },
          { nameFr: 'Malosse', nameEn: 'Houndour', slug: 'houndour', type: 'fire', baseHp: 35, baseAtk: 7 },
          { nameFr: 'Tournegrin', nameEn: 'Sunkern', slug: 'sunkern', type: 'grass', baseHp: 20, baseAtk: 3 },
          { nameFr: 'Natu', nameEn: 'Natu', slug: 'natu', type: 'psychic', baseHp: 30, baseAtk: 4 },
          { nameFr: 'Pichu', nameEn: 'Pichu', slug: 'pichu', type: 'electric', baseHp: 30, baseAtk: 5 },
        ],
        boss: {
          nameFr: 'Albert',
          nameEn: 'Falkner',
          slug: 'falkner',
          types: ['flying'],
          team: [
            { nameFr: 'Roucool', nameEn: 'Pidgey', slug: 'pidgey', level: 7 },
            { nameFr: 'Roucoups', nameEn: 'Pidgeotto', slug: 'pidgeotto', level: 9 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 2,
        nameFr: 'Bois aux Chênes — Hector',
        nameEn: 'Azalea Town — Bugsy',
        types: ['bug', 'grass'],
        wild: [
          { nameFr: 'Mimigal', nameEn: 'Spinarak', slug: 'spinarak', type: 'bug', baseHp: 30, baseAtk: 6 },
          { nameFr: 'Coxy', nameEn: 'Ledyba', slug: 'ledyba', type: 'bug', baseHp: 30, baseAtk: 4 },
          { nameFr: 'Granivol', nameEn: 'Hoppip', slug: 'hoppip', type: 'grass', baseHp: 25, baseAtk: 4 },
          { nameFr: 'Germignon', nameEn: 'Chikorita', slug: 'chikorita', type: 'grass', baseHp: 35, baseAtk: 5 },
          { nameFr: 'Natu', nameEn: 'Natu', slug: 'natu', type: 'psychic', baseHp: 29, baseAtk: 5 },
          { nameFr: 'Pichu', nameEn: 'Pichu', slug: 'pichu', type: 'electric', baseHp: 29, baseAtk: 5 },
        ],
        boss: {
          nameFr: 'Hector',
          nameEn: 'Bugsy',
          slug: 'bugsy',
          types: ['bug'],
          team: [
            { nameFr: 'Coconfort', nameEn: 'Kakuna', slug: 'kakuna', level: 14 },
            { nameFr: 'Insécateur', nameEn: 'Scyther', slug: 'scyther', level: 16 },
            { nameFr: 'Chrysacier', nameEn: 'Metapod', slug: 'metapod', level: 14 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 3,
        nameFr: 'Doublonville — Blanche',
        nameEn: 'Goldenrod City — Whitney',
        types: ['normal', 'fairy'],
        wild: [
          { nameFr: 'Snubbull', nameEn: 'Snubbull', slug: 'snubbull', type: 'fairy', baseHp: 50, baseAtk: 8 },
          { nameFr: 'Queulorior', nameEn: 'Smeargle', slug: 'smeargle', type: 'normal', baseHp: 40, baseAtk: 3 },
          { nameFr: 'Leveinard', nameEn: 'Chansey', slug: 'chansey', type: 'normal', baseHp: 100, baseAtk: 3 },
          { nameFr: 'Écrémeuh', nameEn: 'Miltank', slug: 'miltank', type: 'normal', baseHp: 70, baseAtk: 8 },
          { nameFr: 'Marill', nameEn: 'Marill', slug: 'marill', type: 'water', baseHp: 56, baseAtk: 5 },
          { nameFr: 'Cerfrousse', nameEn: 'Stantler', slug: 'stantler', type: 'normal', baseHp: 59, baseAtk: 5 },
          { nameFr: 'Yanma', nameEn: 'Yanma', slug: 'yanma', type: 'bug', baseHp: 61, baseAtk: 5 },
        ],
        boss: {
          nameFr: 'Blanche',
          nameEn: 'Whitney',
          slug: 'whitney',
          types: ['normal'],
          team: [
            { nameFr: 'Mélofée', nameEn: 'Clefairy', slug: 'clefairy', level: 18 },
            { nameFr: 'Écrémeuh', nameEn: 'Miltank', slug: 'miltank', level: 20 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 4,
        nameFr: 'Rosalia — Mortimer',
        nameEn: 'Ecruteak City — Morty',
        types: ['ghost', 'fire'],
        wild: [
          { nameFr: 'Fantominus', nameEn: 'Gastly', slug: 'gastly', type: 'ghost', baseHp: 30, baseAtk: 10 },
          { nameFr: 'Feuforêve', nameEn: 'Misdreavus', slug: 'misdreavus', type: 'ghost', baseHp: 45, baseAtk: 8 },
          { nameFr: 'Caninos', nameEn: 'Growlithe', slug: 'growlithe', type: 'fire', baseHp: 55, baseAtk: 7 },
          { nameFr: 'Magby', nameEn: 'Magby', slug: 'magby', type: 'fire', baseHp: 35, baseAtk: 8 },
          { nameFr: 'Capumain', nameEn: 'Aipom', slug: 'aipom', type: 'normal', baseHp: 40, baseAtk: 8 },
          { nameFr: 'Phanpy', nameEn: 'Phanpy', slug: 'phanpy', type: 'ground', baseHp: 39, baseAtk: 8 },
        ],
        boss: {
          nameFr: 'Mortimer',
          nameEn: 'Morty',
          slug: 'morty',
          types: ['ghost'],
          team: [
            { nameFr: 'Fantominus', nameEn: 'Gastly', slug: 'gastly', level: 21 },
            { nameFr: 'Spectrum', nameEn: 'Haunter', slug: 'haunter', level: 21 },
            { nameFr: 'Spectrum', nameEn: 'Haunter', slug: 'haunter', level: 23 },
            { nameFr: 'Ectoplasma', nameEn: 'Gengar', slug: 'gengar', level: 25 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 5,
        nameFr: 'Irisia — Chuck',
        nameEn: 'Cianwood City — Chuck',
        types: ['fighting'],
        wild: [
          { nameFr: 'Machoc', nameEn: 'Machop', slug: 'machop', type: 'fighting', baseHp: 50, baseAtk: 7 },
          { nameFr: 'Têtarte', nameEn: 'Poliwhirl', slug: 'poliwhirl', type: 'water', baseHp: 55, baseAtk: 6 },
          { nameFr: 'Krabby', nameEn: 'Krabby', slug: 'krabby', type: 'water', baseHp: 30, baseAtk: 10 },
          { nameFr: 'Tentacool', nameEn: 'Tentacool', slug: 'tentacool', type: 'water', baseHp: 30, baseAtk: 5 },
          { nameFr: 'Togepi', nameEn: 'Togepi', slug: 'togepi', type: 'fairy', baseHp: 39, baseAtk: 6 },
          { nameFr: 'Insolourdo', nameEn: 'Dunsparce', slug: 'dunsparce', type: 'normal', baseHp: 37, baseAtk: 6 },
        ],
        boss: {
          nameFr: 'Chuck',
          nameEn: 'Chuck',
          slug: 'chuck',
          types: ['fighting'],
          team: [
            { nameFr: 'Colossinge', nameEn: 'Primeape', slug: 'primeape', level: 27 },
            { nameFr: 'Tartard', nameEn: 'Poliwrath', slug: 'poliwrath', level: 30 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 6,
        nameFr: 'Oliville — Jasmine',
        nameEn: 'Olivine City — Jasmine',
        types: ['steel', 'electric'],
        wild: [
          { nameFr: 'Magnéti', nameEn: 'Magnemite', slug: 'magnemite', type: 'electric', baseHp: 25, baseAtk: 10 },
          { nameFr: 'Steelix', nameEn: 'Steelix', slug: 'steelix', type: 'steel', baseHp: 60, baseAtk: 8 },
          { nameFr: 'Wattouat', nameEn: 'Mareep', slug: 'mareep', type: 'electric', baseHp: 40, baseAtk: 6 },
          { nameFr: 'Voltorbe', nameEn: 'Voltorb', slug: 'voltorb', type: 'electric', baseHp: 30, baseAtk: 7 },
          { nameFr: 'Limagma', nameEn: 'Slugma', slug: 'slugma', type: 'fire', baseHp: 36, baseAtk: 8 },
          { nameFr: 'Simularbre', nameEn: 'Sudowoodo', slug: 'sudowoodo', type: 'rock', baseHp: 37, baseAtk: 8 },
          { nameFr: 'Yanma', nameEn: 'Yanma', slug: 'yanma', type: 'bug', baseHp: 35, baseAtk: 7 },
        ],
        boss: {
          nameFr: 'Jasmine',
          nameEn: 'Jasmine',
          slug: 'jasmine',
          types: ['steel'],
          team: [
            { nameFr: 'Magnéti', nameEn: 'Magnemite', slug: 'magnemite', level: 30 },
            { nameFr: 'Steelix', nameEn: 'Steelix', slug: 'steelix', level: 35 },
            { nameFr: 'Magnéti', nameEn: 'Magnemite', slug: 'magnemite', level: 30 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 7,
        nameFr: 'Acajou — Frédo',
        nameEn: 'Mahogany Town — Pryce',
        types: ['ice', 'water'],
        wild: [
          { nameFr: 'Marcacrin', nameEn: 'Swinub', slug: 'swinub', type: 'ice', baseHp: 40, baseAtk: 6 },
          { nameFr: 'Cadoizo', nameEn: 'Delibird', slug: 'delibird', type: 'ice', baseHp: 35, baseAtk: 5 },
          { nameFr: 'Otaria', nameEn: 'Seel', slug: 'seel', type: 'water', baseHp: 55, baseAtk: 5 },
          { nameFr: 'Lamantine', nameEn: 'Dewgong', slug: 'dewgong', type: 'ice', baseHp: 70, baseAtk: 7 },
          { nameFr: 'Axoloto', nameEn: 'Wooper', slug: 'wooper', type: 'water', baseHp: 47, baseAtk: 6 },
          { nameFr: 'Teddiursa', nameEn: 'Teddiursa', slug: 'teddiursa', type: 'normal', baseHp: 48, baseAtk: 6 },
        ],
        boss: {
          nameFr: 'Frédo',
          nameEn: 'Pryce',
          slug: 'pryce',
          types: ['ice'],
          team: [
            { nameFr: 'Lamantine', nameEn: 'Dewgong', slug: 'dewgong', level: 30 },
            { nameFr: 'Cochignon', nameEn: 'Piloswine', slug: 'piloswine', level: 34 },
            { nameFr: 'Crustabri', nameEn: 'Cloyster', slug: 'cloyster', level: 32 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 8,
        nameFr: 'Ébènelle — Sandra',
        nameEn: 'Blackthorn City — Clair',
        types: ['dragon', 'flying'],
        wild: [
          { nameFr: 'Draco', nameEn: 'Dragonair', slug: 'dragonair', type: 'dragon', baseHp: 60, baseAtk: 8 },
          { nameFr: 'Cornèbre', nameEn: 'Murkrow', slug: 'murkrow', type: 'dark', baseHp: 40, baseAtk: 8 },
          { nameFr: 'Airmure', nameEn: 'Skarmory', slug: 'skarmory', type: 'steel', baseHp: 55, baseAtk: 8 },
          { nameFr: 'Minidraco', nameEn: 'Dratini', slug: 'dratini', type: 'dragon', baseHp: 35, baseAtk: 6 },
          { nameFr: 'Élekid', nameEn: 'Elekid', slug: 'elekid', type: 'electric', baseHp: 47, baseAtk: 7 },
          { nameFr: 'Loupio', nameEn: 'Chinchou', slug: 'chinchou', type: 'electric', baseHp: 44, baseAtk: 7 },
        ],
        boss: {
          nameFr: 'Sandra',
          nameEn: 'Clair',
          slug: 'clair',
          types: ['dragon'],
          team: [
            { nameFr: 'Draco', nameEn: 'Dragonair', slug: 'dragonair', level: 37 },
            { nameFr: 'Draco', nameEn: 'Dragonair', slug: 'dragonair', level: 37 },
            { nameFr: 'Léviator', nameEn: 'Gyarados', slug: 'gyarados', level: 38 },
            { nameFr: 'Dracolosse', nameEn: 'Dragonite', slug: 'dragonite', level: 40 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 9,
        nameFr: 'Clément (Conseil 4)',
        nameEn: 'Will (Elite Four)',
        types: ['psychic'],
        wild: [
          { nameFr: 'Corayon', nameEn: 'Corsola', slug: 'corsola', type: 'water', baseHp: 30, baseAtk: 7 },
          { nameFr: 'Xatu', nameEn: 'Xatu', slug: 'xatu', type: 'psychic', baseHp: 55, baseAtk: 9 },
          { nameFr: 'Mentali', nameEn: 'Espeon', slug: 'espeon', type: 'psychic', baseHp: 55, baseAtk: 13 },
          { nameFr: 'Qulbutoké', nameEn: 'Wobbuffet', slug: 'wobbuffet', type: 'psychic', baseHp: 120, baseAtk: 3 },
          { nameFr: 'Rémoraid', nameEn: 'Remoraid', slug: 'remoraid', type: 'water', baseHp: 61, baseAtk: 6 },
          { nameFr: 'Toudoudou', nameEn: 'Igglybuff', slug: 'igglybuff', type: 'fairy', baseHp: 60, baseAtk: 6 },
          { nameFr: 'Pomdepik', nameEn: 'Pineco', slug: 'pineco', type: 'bug', baseHp: 55, baseAtk: 6 },
        ],
        boss: {
          nameFr: 'Clément',
          nameEn: 'Will',
          slug: 'will',
          types: ['psychic'],
          team: [
            { nameFr: 'Xatu', nameEn: 'Xatu', slug: 'xatu', level: 40 },
            { nameFr: 'Lippoutou', nameEn: 'Jynx', slug: 'jynx', level: 41 },
            { nameFr: 'Mentali', nameEn: 'Espeon', slug: 'espeon', level: 41 },
            { nameFr: 'Flagadoss', nameEn: 'Slowbro', slug: 'slowbro', level: 41 },
            { nameFr: 'Xatu', nameEn: 'Xatu', slug: 'xatu', level: 42 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 10,
        nameFr: 'Koga (Conseil 4)',
        nameEn: 'Koga (Elite Four)',
        types: ['poison'],
        wild: [
          { nameFr: 'Arbok', nameEn: 'Arbok', slug: 'arbok', type: 'poison', baseHp: 60, baseAtk: 9 },
          { nameFr: 'Scorplane', nameEn: 'Gligar', slug: 'gligar', type: 'ground', baseHp: 55, baseAtk: 8 },
          { nameFr: 'Smogogo', nameEn: 'Weezing', slug: 'weezing', type: 'poison', baseHp: 55, baseAtk: 9 },
          { nameFr: 'Grotadmorv', nameEn: 'Muk', slug: 'muk', type: 'poison', baseHp: 80, baseAtk: 10 },
          { nameFr: 'Embrylex', nameEn: 'Larvitar', slug: 'larvitar', type: 'rock', baseHp: 59, baseAtk: 9 },
          { nameFr: 'Caratroc', nameEn: 'Shuckle', slug: 'shuckle', type: 'bug', baseHp: 62, baseAtk: 9 },
        ],
        boss: {
          nameFr: 'Koga',
          nameEn: 'Koga',
          slug: 'koga-gen2',
          types: ['poison'],
          team: [
            { nameFr: 'Arbok', nameEn: 'Arbok', slug: 'arbok', level: 42 },
            { nameFr: 'Nostenfer', nameEn: 'Crobat', slug: 'crobat', level: 44 },
            { nameFr: 'Smogogo', nameEn: 'Weezing', slug: 'weezing', level: 43 },
            { nameFr: 'Grotadmorv', nameEn: 'Muk', slug: 'muk', level: 43 },
            { nameFr: 'Abo', nameEn: 'Ekans', slug: 'ekans', level: 44 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 11,
        nameFr: 'Aldo (Conseil 4)',
        nameEn: 'Bruno (Elite Four)',
        types: ['fighting'],
        wild: [
          { nameFr: 'Kapoera', nameEn: 'Hitmontop', slug: 'hitmontop', type: 'fighting', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Mackogneur', nameEn: 'Machamp', slug: 'machamp', type: 'fighting', baseHp: 80, baseAtk: 13 },
          { nameFr: 'Kicklee', nameEn: 'Hitmonlee', slug: 'hitmonlee', type: 'fighting', baseHp: 50, baseAtk: 12 },
          { nameFr: 'Tygnon', nameEn: 'Hitmonchan', slug: 'hitmonchan', type: 'fighting', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Girafarig', nameEn: 'Girafarig', slug: 'girafarig', type: 'psychic', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Lippouti', nameEn: 'Smoochum', slug: 'smoochum', type: 'ice', baseHp: 58, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Aldo',
          nameEn: 'Bruno',
          slug: 'bruno-gen2',
          types: ['fighting'],
          team: [
            { nameFr: 'Kapoera', nameEn: 'Hitmontop', slug: 'hitmontop', level: 42 },
            { nameFr: 'Kicklee', nameEn: 'Hitmonlee', slug: 'hitmonlee', level: 43 },
            { nameFr: 'Tygnon', nameEn: 'Hitmonchan', slug: 'hitmonchan', level: 43 },
            { nameFr: 'Onix', nameEn: 'Onix', slug: 'onix', level: 44 },
            { nameFr: 'Mackogneur', nameEn: 'Machamp', slug: 'machamp', level: 46 },
          ],
          timerSeconds: 35,
        },
      },
      {
        id: 12,
        nameFr: 'Marion (Conseil 4)',
        nameEn: 'Karen (Elite Four)',
        types: ['dark'],
        wild: [
          { nameFr: 'Noctali', nameEn: 'Umbreon', slug: 'umbreon', type: 'dark', baseHp: 70, baseAtk: 7 },
          { nameFr: 'Démolosse', nameEn: 'Houndoom', slug: 'houndoom', type: 'dark', baseHp: 60, baseAtk: 11 },
          { nameFr: 'Cornèbre', nameEn: 'Murkrow', slug: 'murkrow', type: 'dark', baseHp: 40, baseAtk: 8 },
          { nameFr: 'Farfuret', nameEn: 'Sneasel', slug: 'sneasel', type: 'dark', baseHp: 45, baseAtk: 10 },
          { nameFr: 'Qwilfish', nameEn: 'Qwilfish', slug: 'qwilfish', type: 'poison', baseHp: 53, baseAtk: 9 },
          { nameFr: 'Démanta', nameEn: 'Mantine', slug: 'mantine', type: 'water', baseHp: 47, baseAtk: 9 },
          { nameFr: 'Scarhino', nameEn: 'Heracross', slug: 'heracross', type: 'bug', baseHp: 48, baseAtk: 9 },
        ],
        boss: {
          nameFr: 'Marion',
          nameEn: 'Karen',
          slug: 'karen',
          types: ['dark'],
          team: [
            { nameFr: 'Noctali', nameEn: 'Umbreon', slug: 'umbreon', level: 42 },
            { nameFr: 'Démolosse', nameEn: 'Houndoom', slug: 'houndoom', level: 47 },
            { nameFr: 'Farfuret', nameEn: 'Sneasel', slug: 'sneasel', level: 44 },
            { nameFr: 'Cornèbre', nameEn: 'Murkrow', slug: 'murkrow', level: 44 },
            { nameFr: 'Léviator', nameEn: 'Gyarados', slug: 'gyarados', level: 46 },
          ],
          timerSeconds: 40,
        },
      },
      {
        id: 13,
        nameFr: 'Maître — Peter',
        nameEn: 'Champion — Lance',
        types: ['dragon', 'flying'],
        wild: [
          { nameFr: 'Dracolosse', nameEn: 'Dragonite', slug: 'dragonite', type: 'dragon', baseHp: 90, baseAtk: 14 },
          { nameFr: 'Ptéra', nameEn: 'Aerodactyl', slug: 'aerodactyl', type: 'rock', baseHp: 70, baseAtk: 10 },
          { nameFr: 'Léviator', nameEn: 'Gyarados', slug: 'gyarados', type: 'water', baseHp: 80, baseAtk: 12 },
          { nameFr: 'Dracaufeu', nameEn: 'Charizard', slug: 'charizard', type: 'fire', baseHp: 70, baseAtk: 11 },
          { nameFr: 'Debugant', nameEn: 'Tyrogue', slug: 'tyrogue', type: 'fighting', baseHp: 75, baseAtk: 12 },
          { nameFr: 'Zarbi', nameEn: 'Unown', slug: 'unown', type: 'psychic', baseHp: 77, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Peter',
          nameEn: 'Lance',
          slug: 'lance-gen2',
          types: ['dragon', 'flying'],
          team: [
            { nameFr: 'Léviator', nameEn: 'Gyarados', slug: 'gyarados', level: 44 },
            { nameFr: 'Dracolosse', nameEn: 'Dragonite', slug: 'dragonite', level: 49 },
            { nameFr: 'Dracolosse', nameEn: 'Dragonite', slug: 'dragonite', level: 49 },
            { nameFr: 'Ptéra', nameEn: 'Aerodactyl', slug: 'aerodactyl', level: 48 },
            { nameFr: 'Dracaufeu', nameEn: 'Charizard', slug: 'charizard', level: 48 },
            { nameFr: 'Dracolosse', nameEn: 'Dragonite', slug: 'dragonite', level: 50 },
          ],
          timerSeconds: 45,
        },
      },
    ],
  },
  {
    id: 3,
    nameFr: 'Génération III',
    nameEn: 'Generation III',
    regionFr: 'Hoenn',
    regionEn: 'Hoenn',
    zones: [
      {
        id: 1,
        nameFr: 'Route 101 — Roxanne',
        nameEn: 'Route 101 — Roxanne',
        types: ['normal', 'grass'],
        wild: [
          { nameFr: 'Zigzaton', nameEn: 'Zigzagoon', slug: 'zigzagoon', type: 'normal', baseHp: 30, baseAtk: 4 },
          { nameFr: 'Medhyèna', nameEn: 'Poochyena', slug: 'poochyena', type: 'dark', baseHp: 30, baseAtk: 5 },
          { nameFr: 'Tarsal', nameEn: 'Ralts', slug: 'ralts', type: 'psychic', baseHp: 20, baseAtk: 5 },
          { nameFr: 'Chenipotte', nameEn: 'Wurmple', slug: 'wurmple', type: 'bug', baseHp: 25, baseAtk: 3 },
          { nameFr: 'Nirondelle', nameEn: 'Taillow', slug: 'taillow', type: 'flying', baseHp: 24, baseAtk: 4 },
          { nameFr: 'Chuchmur', nameEn: 'Whismur', slug: 'whismur', type: 'normal', baseHp: 23, baseAtk: 4 },
        ],
        boss: {
          nameFr: 'Roxanne',
          nameEn: 'Roxanne',
          slug: 'roxanne',
          types: ['rock'],
          team: [
            { nameFr: 'Racaillou', nameEn: 'Geodude', slug: 'geodude', level: 12 },
            { nameFr: 'Racaillou', nameEn: 'Geodude', slug: 'geodude', level: 12 },
            { nameFr: 'Tarinor', nameEn: 'Nosepass', slug: 'nosepass', level: 15 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 2,
        nameFr: 'Île de Myokara — Bastien',
        nameEn: 'Dewford Town — Brawly',
        types: ['fighting', 'dark'],
        wild: [
          { nameFr: 'Machoc', nameEn: 'Machop', slug: 'machop', type: 'fighting', baseHp: 50, baseAtk: 7 },
          { nameFr: 'Makuhita', nameEn: 'Makuhita', slug: 'makuhita', type: 'fighting', baseHp: 55, baseAtk: 7 },
          { nameFr: 'Ténéfix', nameEn: 'Sableye', slug: 'sableye', type: 'dark', baseHp: 40, baseAtk: 7 },
          { nameFr: 'Mysdibule', nameEn: 'Mawile', slug: 'mawile', type: 'steel', baseHp: 40, baseAtk: 8 },
          { nameFr: 'Zigzaton', nameEn: 'Zigzagoon', slug: 'zigzagoon', type: 'normal', baseHp: 46, baseAtk: 7 },
          { nameFr: 'Medhyèna', nameEn: 'Poochyena', slug: 'poochyena', type: 'dark', baseHp: 44, baseAtk: 7 },
          { nameFr: 'Nirondelle', nameEn: 'Taillow', slug: 'taillow', type: 'flying', baseHp: 45, baseAtk: 7 },
        ],
        boss: {
          nameFr: 'Bastien',
          nameEn: 'Brawly',
          slug: 'brawly',
          types: ['fighting'],
          team: [
            { nameFr: 'Machoc', nameEn: 'Machop', slug: 'machop', level: 16 },
            { nameFr: 'Méditikka', nameEn: 'Meditite', slug: 'meditite', level: 16 },
            { nameFr: 'Makuhita', nameEn: 'Makuhita', slug: 'makuhita', level: 19 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 3,
        nameFr: 'Lavandia — Voltère',
        nameEn: 'Mauville City — Wattson',
        types: ['electric'],
        wild: [
          { nameFr: 'Magnéti', nameEn: 'Magnemite', slug: 'magnemite', type: 'electric', baseHp: 25, baseAtk: 10 },
          { nameFr: 'Voltorbe', nameEn: 'Voltorb', slug: 'voltorb', type: 'electric', baseHp: 30, baseAtk: 7 },
          { nameFr: 'Dynavolt', nameEn: 'Electrike', slug: 'electrike', type: 'electric', baseHp: 30, baseAtk: 7 },
          { nameFr: 'Posipi', nameEn: 'Plusle', slug: 'plusle', type: 'electric', baseHp: 40, baseAtk: 6 },
          { nameFr: 'Nénupiot', nameEn: 'Lotad', slug: 'lotad', type: 'water', baseHp: 29, baseAtk: 7 },
          { nameFr: 'Morphéo', nameEn: 'Castform', slug: 'castform', type: 'normal', baseHp: 30, baseAtk: 8 },
        ],
        boss: {
          nameFr: 'Voltère',
          nameEn: 'Wattson',
          slug: 'wattson',
          types: ['electric'],
          team: [
            { nameFr: 'Voltorbe', nameEn: 'Voltorb', slug: 'voltorb', level: 20 },
            { nameFr: 'Dynavolt', nameEn: 'Electrike', slug: 'electrike', level: 20 },
            { nameFr: 'Magnéton', nameEn: 'Magneton', slug: 'magneton', level: 22 },
            { nameFr: 'Élecsprint', nameEn: 'Manectric', slug: 'manectric', level: 24 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 4,
        nameFr: 'Vermilava — Adriane',
        nameEn: 'Lavaridge Town — Flannery',
        types: ['fire', 'ground'],
        wild: [
          { nameFr: 'Chamallot', nameEn: 'Numel', slug: 'numel', type: 'fire', baseHp: 50, baseAtk: 6 },
          { nameFr: 'Chartor', nameEn: 'Torkoal', slug: 'torkoal', type: 'fire', baseHp: 55, baseAtk: 8 },
          { nameFr: 'Kraknoix', nameEn: 'Trapinch', slug: 'trapinch', type: 'ground', baseHp: 35, baseAtk: 10 },
          { nameFr: 'Limagma', nameEn: 'Slugma', slug: 'slugma', type: 'fire', baseHp: 30, baseAtk: 7 },
          { nameFr: 'Grainipiot', nameEn: 'Seedot', slug: 'seedot', type: 'grass', baseHp: 38, baseAtk: 8 },
          { nameFr: 'Terhal', nameEn: 'Beldum', slug: 'beldum', type: 'steel', baseHp: 40, baseAtk: 8 },
        ],
        boss: {
          nameFr: 'Adriane',
          nameEn: 'Flannery',
          slug: 'flannery',
          types: ['fire'],
          team: [
            { nameFr: 'Chamallot', nameEn: 'Numel', slug: 'numel', level: 24 },
            { nameFr: 'Limagma', nameEn: 'Slugma', slug: 'slugma', level: 24 },
            { nameFr: 'Camérupt', nameEn: 'Camerupt', slug: 'camerupt', level: 26 },
            { nameFr: 'Chartor', nameEn: 'Torkoal', slug: 'torkoal', level: 29 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 5,
        nameFr: 'Clémenti-Ville — Norman',
        nameEn: 'Petalburg City — Norman',
        types: ['normal'],
        wild: [
          { nameFr: 'Parecool', nameEn: 'Slakoth', slug: 'slakoth', type: 'normal', baseHp: 50, baseAtk: 6 },
          { nameFr: 'Vigoroth', nameEn: 'Vigoroth', slug: 'vigoroth', type: 'normal', baseHp: 60, baseAtk: 8 },
          { nameFr: 'Spinda', nameEn: 'Spinda', slug: 'spinda', type: 'normal', baseHp: 50, baseAtk: 6 },
          { nameFr: 'Chuchmur', nameEn: 'Whismur', slug: 'whismur', type: 'normal', baseHp: 45, baseAtk: 5 },
          { nameFr: 'Skitty', nameEn: 'Skitty', slug: 'skitty', type: 'normal', baseHp: 50, baseAtk: 6 },
          { nameFr: 'Relicanth', nameEn: 'Relicanth', slug: 'relicanth', type: 'rock', baseHp: 49, baseAtk: 6 },
          { nameFr: 'Machoc', nameEn: 'Machop', slug: 'machop', type: 'fighting', baseHp: 49, baseAtk: 6 },
        ],
        boss: {
          nameFr: 'Norman',
          nameEn: 'Norman',
          slug: 'norman',
          types: ['normal'],
          team: [
            { nameFr: 'Spinda', nameEn: 'Spinda', slug: 'spinda', level: 27 },
            { nameFr: 'Vigoroth', nameEn: 'Vigoroth', slug: 'vigoroth', level: 27 },
            { nameFr: 'Monaflèmit', nameEn: 'Slaking', slug: 'slaking', level: 31 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 6,
        nameFr: 'Cimetronelle — Alizée',
        nameEn: 'Fortree City — Winona',
        types: ['flying', 'grass'],
        wild: [
          { nameFr: 'Makuhita', nameEn: 'Makuhita', slug: 'makuhita', type: 'fighting', baseHp: 30, baseAtk: 6 },
          { nameFr: 'Hélédelle', nameEn: 'Swellow', slug: 'swellow', type: 'flying', baseHp: 50, baseAtk: 8 },
          { nameFr: 'Tropius', nameEn: 'Tropius', slug: 'tropius', type: 'grass', baseHp: 80, baseAtk: 7 },
          { nameFr: 'Altaria', nameEn: 'Altaria', slug: 'altaria', type: 'dragon', baseHp: 60, baseAtk: 7 },
          { nameFr: 'Tarinor', nameEn: 'Nosepass', slug: 'nosepass', type: 'rock', baseHp: 53, baseAtk: 7 },
          { nameFr: 'Galekid', nameEn: 'Aron', slug: 'aron', type: 'steel', baseHp: 47, baseAtk: 7 },
        ],
        boss: {
          nameFr: 'Alizée',
          nameEn: 'Winona',
          slug: 'winona',
          types: ['flying'],
          team: [
            { nameFr: 'Hélédelle', nameEn: 'Swellow', slug: 'swellow', level: 31 },
            { nameFr: 'Charmillon', nameEn: 'Beautifly', slug: 'beautifly', level: 31 },
            { nameFr: 'Altaria', nameEn: 'Altaria', slug: 'altaria', level: 33 },
            { nameFr: 'Airmure', nameEn: 'Skarmory', slug: 'skarmory', level: 33 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 7,
        nameFr: 'Algatia — Lévy & Tatia',
        nameEn: 'Mossdeep City — Tate & Liza',
        types: ['psychic'],
        wild: [
          { nameFr: 'Spoink', nameEn: 'Spoink', slug: 'spoink', type: 'psychic', baseHp: 40, baseAtk: 5 },
          { nameFr: 'Groret', nameEn: 'Grumpig', slug: 'grumpig', type: 'psychic', baseHp: 70, baseAtk: 7 },
          { nameFr: 'Kecleon', nameEn: 'Kecleon', slug: 'kecleon', type: 'normal', baseHp: 50, baseAtk: 9 },
          { nameFr: 'Balbuto', nameEn: 'Baltoy', slug: 'baltoy', type: 'psychic', baseHp: 30, baseAtk: 5 },
          { nameFr: 'Barloche', nameEn: 'Barboach', slug: 'barboach', type: 'water', baseHp: 44, baseAtk: 7 },
          { nameFr: 'Arakdo', nameEn: 'Surskit', slug: 'surskit', type: 'water', baseHp: 42, baseAtk: 7 },
        ],
        boss: {
          nameFr: 'Lévy & Tatia',
          nameEn: 'Tate & Liza',
          slug: 'liza',
          types: ['psychic'],
          team: [
            { nameFr: 'Solaroc', nameEn: 'Solrock', slug: 'solrock', level: 42 },
            { nameFr: 'Séléroc', nameEn: 'Lunatone', slug: 'lunatone', level: 42 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 8,
        nameFr: 'Atalanopolis — Marc',
        nameEn: 'Sootopolis City — Wallace',
        types: ['water'],
        wild: [
          { nameFr: 'Wailmer', nameEn: 'Wailmer', slug: 'wailmer', type: 'water', baseHp: 90, baseAtk: 5 },
          { nameFr: 'Carvanha', nameEn: 'Carvanha', slug: 'carvanha', type: 'water', baseHp: 35, baseAtk: 9 },
          { nameFr: 'Lovdisc', nameEn: 'Luvdisc', slug: 'luvdisc', type: 'water', baseHp: 35, baseAtk: 3 },
          { nameFr: 'Coquiperl', nameEn: 'Clamperl', slug: 'clamperl', type: 'water', baseHp: 30, baseAtk: 6 },
          { nameFr: 'Rosélia', nameEn: 'Roselia', slug: 'roselia', type: 'grass', baseHp: 48, baseAtk: 5 },
          { nameFr: 'Méditikka', nameEn: 'Meditite', slug: 'meditite', type: 'fighting', baseHp: 47, baseAtk: 6 },
          { nameFr: 'Magnéti', nameEn: 'Magnemite', slug: 'magnemite', type: 'electric', baseHp: 44, baseAtk: 6 },
        ],
        boss: {
          nameFr: 'Marc',
          nameEn: 'Wallace',
          slug: 'wallace',
          types: ['water'],
          team: [
            { nameFr: 'Lovdisc', nameEn: 'Luvdisc', slug: 'luvdisc', level: 41 },
            { nameFr: 'Barpau', nameEn: 'Feebas', slug: 'feebas', level: 41 },
            { nameFr: 'Hyporoi', nameEn: 'Kingdra', slug: 'kingdra', level: 43 },
            { nameFr: 'Wailord', nameEn: 'Wailord', slug: 'wailord', level: 43 },
            { nameFr: 'Milobellus', nameEn: 'Milotic', slug: 'milotic', level: 46 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 9,
        nameFr: 'Damien (Conseil 4)',
        nameEn: 'Sidney (Elite Four)',
        types: ['dark'],
        wild: [
          { nameFr: 'Grahyèna', nameEn: 'Mightyena', slug: 'mightyena', type: 'dark', baseHp: 55, baseAtk: 9 },
          { nameFr: 'Ténéfix', nameEn: 'Sableye', slug: 'sableye', type: 'dark', baseHp: 40, baseAtk: 7 },
          { nameFr: 'Cacturne', nameEn: 'Cacturne', slug: 'cacturne', type: 'dark', baseHp: 55, baseAtk: 11 },
          { nameFr: 'Absol', nameEn: 'Absol', slug: 'absol', type: 'dark', baseHp: 55, baseAtk: 13 },
          { nameFr: 'Mangriff', nameEn: 'Zangoose', slug: 'zangoose', type: 'normal', baseHp: 47, baseAtk: 9 },
          { nameFr: 'Goélise', nameEn: 'Wingull', slug: 'wingull', type: 'water', baseHp: 46, baseAtk: 9 },
        ],
        boss: {
          nameFr: 'Damien',
          nameEn: 'Sidney',
          slug: 'sidney',
          types: ['dark'],
          team: [
            { nameFr: 'Grahyèna', nameEn: 'Mightyena', slug: 'mightyena', level: 46 },
            { nameFr: 'Ténéfix', nameEn: 'Sableye', slug: 'sableye', level: 48 },
            { nameFr: 'Cacturne', nameEn: 'Cacturne', slug: 'cacturne', level: 48 },
            { nameFr: 'Tengalice', nameEn: 'Shiftry', slug: 'shiftry', level: 48 },
            { nameFr: 'Absol', nameEn: 'Absol', slug: 'absol', level: 49 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 10,
        nameFr: 'Spectra (Conseil 4)',
        nameEn: 'Phoebe (Elite Four)',
        types: ['ghost'],
        wild: [
          { nameFr: 'Polichombr', nameEn: 'Shuppet', slug: 'shuppet', type: 'ghost', baseHp: 35, baseAtk: 8 },
          { nameFr: 'Branette', nameEn: 'Banette', slug: 'banette', type: 'ghost', baseHp: 50, baseAtk: 11 },
          { nameFr: 'Skelénox', nameEn: 'Duskull', slug: 'duskull', type: 'ghost', baseHp: 20, baseAtk: 4 },
          { nameFr: 'Téraclope', nameEn: 'Dusclops', slug: 'dusclops', type: 'ghost', baseHp: 40, baseAtk: 7 },
          { nameFr: 'Séviper', nameEn: 'Seviper', slug: 'seviper', type: 'poison', baseHp: 33, baseAtk: 6 },
          { nameFr: 'Gloupti', nameEn: 'Gulpin', slug: 'gulpin', type: 'poison', baseHp: 32, baseAtk: 7 },
        ],
        boss: {
          nameFr: 'Spectra',
          nameEn: 'Phoebe',
          slug: 'phoebe-gen3',
          types: ['ghost'],
          team: [
            { nameFr: 'Téraclope', nameEn: 'Dusclops', slug: 'dusclops', level: 48 },
            { nameFr: 'Branette', nameEn: 'Banette', slug: 'banette', level: 49 },
            { nameFr: 'Branette', nameEn: 'Banette', slug: 'banette', level: 49 },
            { nameFr: 'Téraclope', nameEn: 'Dusclops', slug: 'dusclops', level: 51 },
            { nameFr: 'Ténéfix', nameEn: 'Sableye', slug: 'sableye', level: 50 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 11,
        nameFr: 'Glacia (Conseil 4)',
        nameEn: 'Glacia (Elite Four)',
        types: ['ice'],
        wild: [
          { nameFr: 'Obalie', nameEn: 'Spheal', slug: 'spheal', type: 'ice', baseHp: 55, baseAtk: 4 },
          { nameFr: 'Phogleur', nameEn: 'Sealeo', slug: 'sealeo', type: 'ice', baseHp: 80, baseAtk: 6 },
          { nameFr: 'Kaimorse', nameEn: 'Walrein', slug: 'walrein', type: 'ice', baseHp: 100, baseAtk: 8 },
          { nameFr: 'Lippoutou', nameEn: 'Jynx', slug: 'jynx', type: 'ice', baseHp: 55, baseAtk: 10 },
          { nameFr: 'Écrapince', nameEn: 'Corphish', slug: 'corphish', type: 'water', baseHp: 71, baseAtk: 6 },
          { nameFr: 'Rozbouton', nameEn: 'Budew', slug: 'budew', type: 'grass', baseHp: 67, baseAtk: 6 },
          { nameFr: 'Voltorbe', nameEn: 'Voltorb', slug: 'voltorb', type: 'electric', baseHp: 67, baseAtk: 6 },
        ],
        boss: {
          nameFr: 'Glacia',
          nameEn: 'Glacia',
          slug: 'glacia',
          types: ['ice'],
          team: [
            { nameFr: 'Phogleur', nameEn: 'Sealeo', slug: 'sealeo', level: 50 },
            { nameFr: 'Kaimorse', nameEn: 'Walrein', slug: 'walrein', level: 53 },
            { nameFr: 'Phogleur', nameEn: 'Sealeo', slug: 'sealeo', level: 50 },
            { nameFr: 'Oniglali', nameEn: 'Glalie', slug: 'glalie', level: 52 },
            { nameFr: 'Oniglali', nameEn: 'Glalie', slug: 'glalie', level: 52 },
          ],
          timerSeconds: 35,
        },
      },
      {
        id: 12,
        nameFr: 'Aragon (Conseil 4)',
        nameEn: 'Drake (Elite Four)',
        types: ['dragon'],
        wild: [
          { nameFr: 'Draby', nameEn: 'Bagon', slug: 'bagon', type: 'dragon', baseHp: 35, baseAtk: 8 },
          { nameFr: 'Drackhaus', nameEn: 'Shelgon', slug: 'shelgon', type: 'dragon', baseHp: 55, baseAtk: 10 },
          { nameFr: 'Drattak', nameEn: 'Salamence', slug: 'salamence', type: 'dragon', baseHp: 80, baseAtk: 14 },
          { nameFr: 'Libégon', nameEn: 'Flygon', slug: 'flygon', type: 'dragon', baseHp: 65, baseAtk: 10 },
          { nameFr: 'Cacnea', nameEn: 'Cacnea', slug: 'cacnea', type: 'grass', baseHp: 55, baseAtk: 10 },
          { nameFr: 'Tarsal', nameEn: 'Ralts', slug: 'ralts', type: 'psychic', baseHp: 57, baseAtk: 10 },
        ],
        boss: {
          nameFr: 'Aragon',
          nameEn: 'Drake',
          slug: 'drake-gen3',
          types: ['dragon'],
          team: [
            { nameFr: 'Drackhaus', nameEn: 'Shelgon', slug: 'shelgon', level: 52 },
            { nameFr: 'Altaria', nameEn: 'Altaria', slug: 'altaria', level: 54 },
            { nameFr: 'Libégon', nameEn: 'Flygon', slug: 'flygon', level: 53 },
            { nameFr: 'Libégon', nameEn: 'Flygon', slug: 'flygon', level: 53 },
            { nameFr: 'Drattak', nameEn: 'Salamence', slug: 'salamence', level: 55 },
          ],
          timerSeconds: 40,
        },
      },
      {
        id: 13,
        nameFr: 'Maître — Pierre',
        nameEn: 'Champion — Steven',
        types: ['steel', 'rock'],
        wild: [
          { nameFr: 'Métalosse', nameEn: 'Metagross', slug: 'metagross', type: 'steel', baseHp: 70, baseAtk: 14 },
          { nameFr: 'Armaldo', nameEn: 'Armaldo', slug: 'armaldo', type: 'rock', baseHp: 60, baseAtk: 12 },
          { nameFr: 'Mysdibule', nameEn: 'Mawile', slug: 'mawile', type: 'steel', baseHp: 40, baseAtk: 8 },
          { nameFr: 'Galeking', nameEn: 'Aggron', slug: 'aggron', type: 'steel', baseHp: 60, baseAtk: 11 },
          { nameFr: 'Stalgamin', nameEn: 'Snorunt', slug: 'snorunt', type: 'ice', baseHp: 54, baseAtk: 10 },
          { nameFr: 'Chenipotte', nameEn: 'Wurmple', slug: 'wurmple', type: 'bug', baseHp: 51, baseAtk: 10 },
        ],
        boss: {
          nameFr: 'Pierre Rochard',
          nameEn: 'Steven Stone',
          slug: 'steven',
          types: ['steel'],
          team: [
            { nameFr: 'Airmure', nameEn: 'Skarmory', slug: 'skarmory', level: 57 },
            { nameFr: 'Galeking', nameEn: 'Aggron', slug: 'aggron', level: 56 },
            { nameFr: 'Armaldo', nameEn: 'Armaldo', slug: 'armaldo', level: 56 },
            { nameFr: 'Vacilys', nameEn: 'Cradily', slug: 'cradily', level: 56 },
            { nameFr: 'Kaorine', nameEn: 'Claydol', slug: 'claydol', level: 55 },
            { nameFr: 'Métalosse', nameEn: 'Metagross', slug: 'metagross', level: 58 },
          ],
          timerSeconds: 45,
        },
      },
    ],
  },
  {
    id: 4,
    nameFr: 'Génération IV',
    nameEn: 'Generation IV',
    regionFr: 'Sinnoh',
    regionEn: 'Sinnoh',
    zones: [
      {
        id: 1,
        nameFr: 'Champion — Pierrick',
        nameEn: 'Gym Leader — Roark',
        types: ['rock'],
        wild: [
          { nameFr: 'Kranidos', nameEn: 'Cranidos', slug: 'cranidos', type: 'rock', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Dinoclier', nameEn: 'Shieldon', slug: 'shieldon', type: 'rock', baseHp: 45, baseAtk: 9 },
          { nameFr: 'Manzaï', nameEn: 'Bonsly', slug: 'bonsly', type: 'rock', baseHp: 40, baseAtk: 8 },
          { nameFr: 'Archéomire', nameEn: 'Bronzor', slug: 'bronzor', type: 'steel', baseHp: 42, baseAtk: 8 },
          { nameFr: 'Étourmi', nameEn: 'Starly', slug: 'starly', type: 'normal', baseHp: 43, baseAtk: 9 },
          { nameFr: 'Keunotor', nameEn: 'Bidoof', slug: 'bidoof', type: 'normal', baseHp: 44, baseAtk: 9 },
          { nameFr: 'Lixy', nameEn: 'Shinx', slug: 'shinx', type: 'electric', baseHp: 42, baseAtk: 9 },
        ],
        boss: {
          nameFr: 'Pierrick',
          nameEn: 'Roark',
          slug: 'roark',
          types: ['rock'],
          team: [
            { nameFr: 'Archéomire', nameEn: 'Bronzor', slug: 'bronzor', level: 12 },
            { nameFr: 'Dinoclier', nameEn: 'Shieldon', slug: 'shieldon', level: 13 },
            { nameFr: 'Charkos', nameEn: 'Rampardos', slug: 'rampardos', level: 15 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 2,
        nameFr: 'Championne — Flo',
        nameEn: 'Gym Leader — Gardenia',
        types: ['grass'],
        wild: [
          { nameFr: 'Rozbouton', nameEn: 'Budew', slug: 'budew', type: 'grass', baseHp: 45, baseAtk: 8 },
          { nameFr: 'Ceribou', nameEn: 'Cherubi', slug: 'cherubi', type: 'grass', baseHp: 48, baseAtk: 9 },
          { nameFr: 'Cheniti', nameEn: 'Burmy', slug: 'burmy', type: 'bug', baseHp: 42, baseAtk: 7 },
          { nameFr: 'Vortente', nameEn: 'Carnivine', slug: 'carnivine', type: 'grass', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Étourmi', nameEn: 'Starly', slug: 'starly', type: 'normal', baseHp: 45, baseAtk: 8 },
          { nameFr: 'Keunotor', nameEn: 'Bidoof', slug: 'bidoof', type: 'normal', baseHp: 44, baseAtk: 8 },
        ],
        boss: {
          nameFr: 'Flo',
          nameEn: 'Gardenia',
          slug: 'gardenia',
          types: ['grass'],
          team: [
            { nameFr: 'Ceriflor', nameEn: 'Cherrim', slug: 'cherrim', level: 16 },
            { nameFr: 'Torterra', nameEn: 'Torterra', slug: 'torterra', level: 18 },
            { nameFr: 'Roserade', nameEn: 'Roserade', slug: 'roserade', level: 17 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 3,
        nameFr: 'Championne — Mélina',
        nameEn: 'Gym Leader — Maylene',
        types: ['fighting'],
        wild: [
          { nameFr: 'Riolu', nameEn: 'Riolu', slug: 'riolu', type: 'fighting', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Cradopaud', nameEn: 'Croagunk', slug: 'croagunk', type: 'poison', baseHp: 48, baseAtk: 10 },
          { nameFr: 'Méditikka', nameEn: 'Meditite', slug: 'meditite', type: 'fighting', baseHp: 44, baseAtk: 9 },
          { nameFr: 'Machopeur', nameEn: 'Machoke', slug: 'machoke', type: 'fighting', baseHp: 54, baseAtk: 12 },
          { nameFr: 'Laporeille', nameEn: 'Buneary', slug: 'buneary', type: 'normal', baseHp: 47, baseAtk: 11 },
          { nameFr: 'Cheniti', nameEn: 'Burmy', slug: 'burmy', type: 'bug', baseHp: 50, baseAtk: 10 },
        ],
        boss: {
          nameFr: 'Mélina',
          nameEn: 'Maylene',
          slug: 'maylene',
          types: ['fighting'],
          team: [
            { nameFr: 'Charmina', nameEn: 'Medicham', slug: 'medicham', level: 20 },
            { nameFr: 'Lucario', nameEn: 'Lucario', slug: 'lucario', level: 22 },
            { nameFr: 'Mackogneur', nameEn: 'Machamp', slug: 'machamp', level: 21 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 4,
        nameFr: 'Champion — Lovis',
        nameEn: 'Gym Leader — Wake',
        types: ['water'],
        wild: [
          { nameFr: 'Mustébouée', nameEn: 'Buizel', slug: 'buizel', type: 'water', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Sancoki', nameEn: 'Shellos', slug: 'shellos', type: 'water', baseHp: 48, baseAtk: 9 },
          { nameFr: 'Écayon', nameEn: 'Finneon', slug: 'finneon', type: 'water', baseHp: 46, baseAtk: 9 },
          { nameFr: 'Azurill', nameEn: 'Azurill', slug: 'azurill', type: 'normal', baseHp: 42, baseAtk: 8 },
          { nameFr: 'Chaglam', nameEn: 'Glameow', slug: 'glameow', type: 'normal', baseHp: 46, baseAtk: 9 },
          { nameFr: 'Vortente', nameEn: 'Carnivine', slug: 'carnivine', type: 'grass', baseHp: 45, baseAtk: 9 },
          { nameFr: 'Lixy', nameEn: 'Shinx', slug: 'shinx', type: 'electric', baseHp: 45, baseAtk: 9 },
        ],
        boss: {
          nameFr: 'Lovis',
          nameEn: 'Wake',
          slug: 'wake',
          types: ['water'],
          team: [
            { nameFr: 'Luminéon', nameEn: 'Lumineon', slug: 'lumineon', level: 24 },
            { nameFr: 'Mustéflott', nameEn: 'Floatzel', slug: 'floatzel', level: 26 },
            { nameFr: 'Tritosor', nameEn: 'Gastrodon', slug: 'gastrodon', level: 25 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 5,
        nameFr: 'Championne — Kiméra',
        nameEn: 'Gym Leader — Fantina',
        types: ['ghost'],
        wild: [
          { nameFr: 'Baudrive', nameEn: 'Drifloon', slug: 'drifloon', type: 'ghost', baseHp: 52, baseAtk: 10 },
          { nameFr: 'Feuforêve', nameEn: 'Misdreavus', slug: 'misdreavus', type: 'ghost', baseHp: 50, baseAtk: 11 },
          { nameFr: 'Spiritomb', nameEn: 'Spiritomb', slug: 'spiritomb', type: 'ghost', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Spectrum', nameEn: 'Haunter', slug: 'haunter', type: 'ghost', baseHp: 48, baseAtk: 10 },
          { nameFr: 'Moufouette', nameEn: 'Stunky', slug: 'stunky', type: 'poison', baseHp: 50, baseAtk: 11 },
          { nameFr: 'Riolu', nameEn: 'Riolu', slug: 'riolu', type: 'fighting', baseHp: 51, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Kiméra',
          nameEn: 'Fantina',
          slug: 'fantina',
          types: ['ghost'],
          team: [
            { nameFr: 'Grodrive', nameEn: 'Drifblim', slug: 'drifblim', level: 28 },
            { nameFr: 'Magirêve', nameEn: 'Mismagius', slug: 'mismagius', level: 30 },
            { nameFr: 'Ectoplasma', nameEn: 'Gengar', slug: 'gengar', level: 29 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 6,
        nameFr: 'Champion — Charles',
        nameEn: 'Gym Leader — Byron',
        types: ['steel'],
        wild: [
          { nameFr: 'Archéomire', nameEn: 'Bronzor', slug: 'bronzor', type: 'steel', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Dinoclier', nameEn: 'Shieldon', slug: 'shieldon', type: 'rock', baseHp: 52, baseAtk: 10 },
          { nameFr: 'Magnéti', nameEn: 'Magnemite', slug: 'magnemite', type: 'electric', baseHp: 48, baseAtk: 10 },
          { nameFr: 'Steelix', nameEn: 'Steelix', slug: 'steelix', type: 'steel', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Babimanta', nameEn: 'Mantyke', slug: 'mantyke', type: 'water', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Cradopaud', nameEn: 'Croagunk', slug: 'croagunk', type: 'poison', baseHp: 51, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Charles',
          nameEn: 'Byron',
          slug: 'byron',
          types: ['steel'],
          team: [
            { nameFr: 'Archéodong', nameEn: 'Bronzong', slug: 'bronzong', level: 32 },
            { nameFr: 'Bastiodon', nameEn: 'Bastiodon', slug: 'bastiodon', level: 33 },
            { nameFr: 'Steelix', nameEn: 'Steelix', slug: 'steelix', level: 34 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 7,
        nameFr: 'Championne — Gladys',
        nameEn: 'Gym Leader — Candice',
        types: ['ice'],
        wild: [
          { nameFr: 'Blizzi', nameEn: 'Snover', slug: 'snover', type: 'grass', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Stalgamin', nameEn: 'Snorunt', slug: 'snorunt', type: 'ice', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Marcacrin', nameEn: 'Swinub', slug: 'swinub', type: 'ice', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Cadoizo', nameEn: 'Delibird', slug: 'delibird', type: 'ice', baseHp: 48, baseAtk: 9 },
          { nameFr: 'Ptiravi', nameEn: 'Happiny', slug: 'happiny', type: 'normal', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Méditikka', nameEn: 'Meditite', slug: 'meditite', type: 'fighting', baseHp: 51, baseAtk: 10 },
          { nameFr: 'Feuforêve', nameEn: 'Misdreavus', slug: 'misdreavus', type: 'ghost', baseHp: 50, baseAtk: 10 },
        ],
        boss: {
          nameFr: 'Gladys',
          nameEn: 'Candice',
          slug: 'candice',
          types: ['ice'],
          team: [
            { nameFr: 'Blizzaroi', nameEn: 'Abomasnow', slug: 'abomasnow', level: 36 },
            { nameFr: 'Momartik', nameEn: 'Froslass', slug: 'froslass', level: 37 },
            { nameFr: 'Lokhlass', nameEn: 'Lapras', slug: 'lapras', level: 38 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 8,
        nameFr: 'Champion — Tanguy',
        nameEn: 'Gym Leader — Volkner',
        types: ['electric'],
        wild: [
          { nameFr: 'Spectrum', nameEn: 'Haunter', slug: 'haunter', type: 'ghost', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Pachirisu', nameEn: 'Pachirisu', slug: 'pachirisu', type: 'electric', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Motisma', nameEn: 'Rotom', slug: 'rotom', type: 'electric', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Voltali', nameEn: 'Jolteon', slug: 'jolteon', type: 'electric', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Goinfrex', nameEn: 'Munchlax', slug: 'munchlax', type: 'normal', baseHp: 53, baseAtk: 11 },
          { nameFr: 'Machopeur', nameEn: 'Machoke', slug: 'machoke', type: 'fighting', baseHp: 52, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Tanguy',
          nameEn: 'Volkner',
          slug: 'volkner',
          types: ['electric'],
          team: [
            { nameFr: 'Luxray', nameEn: 'Luxray', slug: 'luxray', level: 40 },
            { nameFr: 'Motisma', nameEn: 'Rotom', slug: 'rotom', level: 41 },
            { nameFr: 'Élekable', nameEn: 'Electivire', slug: 'electivire', level: 43 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 9,
        nameFr: 'Conseil 4 — Aaron',
        nameEn: 'Elite Four — Aaron',
        types: ['bug'],
        wild: [
          { nameFr: 'Crikzik', nameEn: 'Kricketot', slug: 'kricketot', type: 'bug', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Apitrini', nameEn: 'Combee', slug: 'combee', type: 'bug', baseHp: 52, baseAtk: 10 },
          { nameFr: 'Rapion', nameEn: 'Skorupi', slug: 'skorupi', type: 'poison', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Yanma', nameEn: 'Yanma', slug: 'yanma', type: 'bug', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Pijako', nameEn: 'Chatot', slug: 'chatot', type: 'normal', baseHp: 53, baseAtk: 11 },
          { nameFr: 'Mustébouée', nameEn: 'Buizel', slug: 'buizel', type: 'water', baseHp: 54, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Aaron',
          nameEn: 'Aaron',
          slug: 'aaron',
          types: ['bug'],
          team: [
            { nameFr: 'Apireine', nameEn: 'Vespiquen', slug: 'vespiquen', level: 46 },
            { nameFr: 'Drascore', nameEn: 'Drapion', slug: 'drapion', level: 47 },
            { nameFr: 'Papilord', nameEn: 'Mothim', slug: 'mothim', level: 46 },
            { nameFr: 'Yanméga', nameEn: 'Yanmega', slug: 'yanmega', level: 47 },
            { nameFr: 'Scarhino', nameEn: 'Heracross', slug: 'heracross', level: 48 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 10,
        nameFr: 'Conseil 4 — Terry',
        nameEn: 'Elite Four — Bertha',
        types: ['ground'],
        wild: [
          { nameFr: 'Hippopotas', nameEn: 'Hippopotas', slug: 'hippopotas', type: 'ground', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Griknot', nameEn: 'Gible', slug: 'gible', type: 'dragon', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Onix', nameEn: 'Onix', slug: 'onix', type: 'rock', baseHp: 54, baseAtk: 10 },
          { nameFr: 'Rhinocorne', nameEn: 'Rhyhorn', slug: 'rhyhorn', type: 'ground', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Kranidos', nameEn: 'Cranidos', slug: 'cranidos', type: 'rock', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Sancoki', nameEn: 'Shellos', slug: 'shellos', type: 'water', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Magnéti', nameEn: 'Magnemite', slug: 'magnemite', type: 'electric', baseHp: 56, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Terry',
          nameEn: 'Bertha',
          slug: 'bertha',
          types: ['ground'],
          team: [
            { nameFr: 'Hippodocus', nameEn: 'Hippowdon', slug: 'hippowdon', level: 48 },
            { nameFr: 'Tritosor', nameEn: 'Gastrodon', slug: 'gastrodon', level: 47 },
            { nameFr: 'Rhinastoc', nameEn: 'Rhyperior', slug: 'rhyperior', level: 49 },
            { nameFr: 'Nidoqueen', nameEn: 'Nidoqueen', slug: 'nidoqueen', level: 47 },
            { nameFr: 'Scorvol', nameEn: 'Gliscor', slug: 'gliscor', level: 50 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 11,
        nameFr: 'Conseil 4 — Adrien',
        nameEn: 'Elite Four — Flint',
        types: ['fire'],
        wild: [
          { nameFr: 'Ouisticram', nameEn: 'Chimchar', slug: 'chimchar', type: 'fire', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Caninos', nameEn: 'Growlithe', slug: 'growlithe', type: 'fire', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Magmar', nameEn: 'Magmar', slug: 'magmar', type: 'fire', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Heatran', nameEn: 'Heatran', slug: 'heatran', type: 'fire', baseHp: 64, baseAtk: 15 },
          { nameFr: 'Manzaï', nameEn: 'Bonsly', slug: 'bonsly', type: 'rock', baseHp: 57, baseAtk: 13 },
          { nameFr: 'Écayon', nameEn: 'Finneon', slug: 'finneon', type: 'water', baseHp: 57, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Adrien',
          nameEn: 'Flint',
          slug: 'flint',
          types: ['fire'],
          team: [
            { nameFr: 'Heatran', nameEn: 'Heatran', slug: 'heatran', level: 50 },
            { nameFr: 'Simiabraz', nameEn: 'Infernape', slug: 'infernape', level: 51 },
            { nameFr: 'Maganon', nameEn: 'Magmortar', slug: 'magmortar', level: 51 },
            { nameFr: 'Arcanin', nameEn: 'Arcanine', slug: 'arcanine', level: 49 },
            { nameFr: 'Dracaufeu', nameEn: 'Charizard', slug: 'charizard', level: 50 },
          ],
          timerSeconds: 35,
        },
      },
      {
        id: 12,
        nameFr: 'Conseil 4 — Lucio',
        nameEn: 'Elite Four — Lucian',
        types: ['psychic'],
        wild: [
          { nameFr: 'Korillon', nameEn: 'Chingling', slug: 'chingling', type: 'psychic', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Mime Jr.', nameEn: 'Mime Jr.', slug: 'mimejr', type: 'psychic', baseHp: 52, baseAtk: 10 },
          { nameFr: 'Créhelf', nameEn: 'Uxie', slug: 'uxie', type: 'psychic', baseHp: 60, baseAtk: 14 },
          { nameFr: 'Créfollet', nameEn: 'Mesprit', slug: 'mesprit', type: 'psychic', baseHp: 60, baseAtk: 14 },
          { nameFr: 'Rozbouton', nameEn: 'Budew', slug: 'budew', type: 'grass', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Azurill', nameEn: 'Azurill', slug: 'azurill', type: 'normal', baseHp: 55, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Lucio',
          nameEn: 'Lucian',
          slug: 'lucian',
          types: ['psychic'],
          team: [
            { nameFr: 'Créhelf', nameEn: 'Uxie', slug: 'uxie', level: 50 },
            { nameFr: 'Créfollet', nameEn: 'Mesprit', slug: 'mesprit', level: 50 },
            { nameFr: 'Créfadet', nameEn: 'Azelf', slug: 'azelf', level: 50 },
            { nameFr: 'Gallame', nameEn: 'Gallade', slug: 'gallade', level: 51 },
            { nameFr: 'Archéodong', nameEn: 'Bronzong', slug: 'bronzong', level: 49 },
          ],
          timerSeconds: 40,
        },
      },
      {
        id: 13,
        nameFr: 'Maître — Cynthia',
        nameEn: 'Champion — Cynthia',
        types: ['dragon', 'ghost'],
        wild: [
          { nameFr: 'Carmache', nameEn: 'Gabite', slug: 'gabite', type: 'dragon', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Lucario', nameEn: 'Lucario', slug: 'lucario', type: 'fighting', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Spiritomb', nameEn: 'Spiritomb', slug: 'spiritomb', type: 'ghost', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Pingoléon', nameEn: 'Empoleon', slug: 'empoleon', type: 'water', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Ceribou', nameEn: 'Cherubi', slug: 'cherubi', type: 'grass', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Baudrive', nameEn: 'Drifloon', slug: 'drifloon', type: 'ghost', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Steelix', nameEn: 'Steelix', slug: 'steelix', type: 'steel', baseHp: 61, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Cynthia',
          nameEn: 'Cynthia',
          slug: 'cynthia',
          types: ['dragon', 'ghost'],
          team: [
            { nameFr: 'Spiritomb', nameEn: 'Spiritomb', slug: 'spiritomb', level: 58 },
            { nameFr: 'Lockpin', nameEn: 'Lopunny', slug: 'lopunny', level: 57 },
            { nameFr: 'Lucario', nameEn: 'Lucario', slug: 'lucario', level: 58 },
            { nameFr: 'Blizzaroi', nameEn: 'Abomasnow', slug: 'abomasnow', level: 57 },
            { nameFr: 'Tritosor', nameEn: 'Gastrodon', slug: 'gastrodon', level: 58 },
            { nameFr: 'Carchacrok', nameEn: 'Garchomp', slug: 'garchomp', level: 62 },
          ],
          timerSeconds: 45,
        },
      },
    ],
  },
  {
    id: 5,
    nameFr: 'Génération V',
    nameEn: 'Generation V',
    regionFr: 'Unys',
    regionEn: 'Unova',
    zones: [
      {
        id: 1,
        nameFr: 'Champion — Rachid',
        nameEn: 'Gym Leader — Cilan',
        types: ['grass'],
        wild: [
          { nameFr: 'Feuillajou', nameEn: 'Pansage', slug: 'pansage', type: 'grass', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Larveyette', nameEn: 'Sewaddle', slug: 'sewaddle', type: 'bug', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Doudouvet', nameEn: 'Cottonee', slug: 'cottonee', type: 'grass', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Chlorobule', nameEn: 'Petilil', slug: 'petilil', type: 'grass', baseHp: 60, baseAtk: 12 },
          { nameFr: 'Ponchiot', nameEn: 'Lillipup', slug: 'lillipup', type: 'normal', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Chacripan', nameEn: 'Purrloin', slug: 'purrloin', type: 'dark', baseHp: 59, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Rachid',
          nameEn: 'Cilan',
          slug: 'cilan',
          types: ['grass'],
          team: [
            { nameFr: 'Manternel', nameEn: 'Leavanny', slug: 'leavanny', level: 14 },
            { nameFr: 'Fragilady', nameEn: 'Lilligant', slug: 'lilligant', level: 15 },
            { nameFr: 'Feuiloutan', nameEn: 'Simisage', slug: 'simisage', level: 16 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 2,
        nameFr: 'Championne — Aloé',
        nameEn: 'Gym Leader — Lenora',
        types: ['normal'],
        wild: [
          { nameFr: 'Ratentif', nameEn: 'Patrat', slug: 'patrat', type: 'normal', baseHp: 60, baseAtk: 12 },
          { nameFr: 'Ponchiot', nameEn: 'Lillipup', slug: 'lillipup', type: 'normal', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Nanméouïe', nameEn: 'Audino', slug: 'audino', type: 'normal', baseHp: 64, baseAtk: 12 },
          { nameFr: 'Chinchidou', nameEn: 'Minccino', slug: 'minccino', type: 'normal', baseHp: 58, baseAtk: 11 },
          { nameFr: 'Chacripan', nameEn: 'Purrloin', slug: 'purrloin', type: 'dark', baseHp: 60, baseAtk: 12 },
          { nameFr: 'Flamajou', nameEn: 'Pansear', slug: 'pansear', type: 'fire', baseHp: 61, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Aloé',
          nameEn: 'Lenora',
          slug: 'lenora',
          types: ['normal'],
          team: [
            { nameFr: 'Mastouffe', nameEn: 'Stoutland', slug: 'stoutland', level: 17 },
            { nameFr: 'Miradar', nameEn: 'Watchog', slug: 'watchog', level: 18 },
            { nameFr: 'Pashmilla', nameEn: 'Cinccino', slug: 'cinccino', level: 19 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 3,
        nameFr: 'Champion — Artie',
        nameEn: 'Gym Leader — Burgh',
        types: ['bug'],
        wild: [
          { nameFr: 'Venipatte', nameEn: 'Venipede', slug: 'venipede', type: 'bug', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Crabicoque', nameEn: 'Dwebble', slug: 'dwebble', type: 'bug', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Carabing', nameEn: 'Karrablast', slug: 'karrablast', type: 'bug', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Escargaume', nameEn: 'Shelmet', slug: 'shelmet', type: 'bug', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Nodulithe', nameEn: 'Roggenrola', slug: 'roggenrola', type: 'rock', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Zébibron', nameEn: 'Blitzle', slug: 'blitzle', type: 'electric', baseHp: 61, baseAtk: 13 },
          { nameFr: 'Flamajou', nameEn: 'Pansear', slug: 'pansear', type: 'fire', baseHp: 60, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Artie',
          nameEn: 'Burgh',
          slug: 'burgh',
          types: ['bug'],
          team: [
            { nameFr: 'Brutapode', nameEn: 'Scolipede', slug: 'scolipede', level: 20 },
            { nameFr: 'Lançargot', nameEn: 'Escavalier', slug: 'escavalier', level: 21 },
            { nameFr: 'Crabaraque', nameEn: 'Crustle', slug: 'crustle', level: 22 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 4,
        nameFr: 'Championne — Inezia',
        nameEn: 'Gym Leader — Elesa',
        types: ['electric'],
        wild: [
          { nameFr: 'Zébibron', nameEn: 'Blitzle', slug: 'blitzle', type: 'electric', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Anchwatt', nameEn: 'Tynamo', slug: 'tynamo', type: 'electric', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Statitik', nameEn: 'Joltik', slug: 'joltik', type: 'bug', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Emolga', nameEn: 'Emolga', slug: 'emolga', type: 'electric', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Trompignon', nameEn: 'Foongus', slug: 'foongus', type: 'grass', baseHp: 59, baseAtk: 13 },
          { nameFr: 'Crabicoque', nameEn: 'Dwebble', slug: 'dwebble', type: 'bug', baseHp: 60, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Inezia',
          nameEn: 'Elesa',
          slug: 'elesa',
          types: ['electric'],
          team: [
            { nameFr: 'Zéblitz', nameEn: 'Zebstrika', slug: 'zebstrika', level: 24 },
            { nameFr: 'Emolga', nameEn: 'Emolga', slug: 'emolga', level: 25 },
            { nameFr: 'Mygavolt', nameEn: 'Galvantula', slug: 'galvantula', level: 26 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 5,
        nameFr: 'Champion — Bardane',
        nameEn: 'Gym Leader — Clay',
        types: ['ground'],
        wild: [
          { nameFr: 'Mascaïman', nameEn: 'Sandile', slug: 'sandile', type: 'ground', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Rototaupe', nameEn: 'Drilbur', slug: 'drilbur', type: 'ground', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Limonde', nameEn: 'Stunfisk', slug: 'stunfisk', type: 'ground', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Tritonde', nameEn: 'Tympole', slug: 'tympole', type: 'water', baseHp: 60, baseAtk: 12 },
          { nameFr: 'Miamiasme', nameEn: 'Trubbish', slug: 'trubbish', type: 'poison', baseHp: 63, baseAtk: 13 },
          { nameFr: 'Carabing', nameEn: 'Karrablast', slug: 'karrablast', type: 'bug', baseHp: 62, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Bardane',
          nameEn: 'Clay',
          slug: 'clay',
          types: ['ground'],
          team: [
            { nameFr: 'Crocorible', nameEn: 'Krookodile', slug: 'krookodile', level: 28 },
            { nameFr: 'Minotaupe', nameEn: 'Excadrill', slug: 'excadrill', level: 29 },
            { nameFr: 'Crapustule', nameEn: 'Seismitoad', slug: 'seismitoad', level: 30 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 6,
        nameFr: 'Championne — Carolina',
        nameEn: 'Gym Leader — Skyla',
        types: ['flying'],
        wild: [
          { nameFr: 'Poichigeon', nameEn: 'Pidove', slug: 'pidove', type: 'normal', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Chovsourir', nameEn: 'Woobat', slug: 'woobat', type: 'psychic', baseHp: 60, baseAtk: 12 },
          { nameFr: 'Couaneton', nameEn: 'Ducklett', slug: 'ducklett', type: 'water', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Furaiglon', nameEn: 'Rufflet', slug: 'rufflet', type: 'normal', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Feuillajou', nameEn: 'Pansage', slug: 'pansage', type: 'grass', baseHp: 63, baseAtk: 14 },
          { nameFr: 'Escargaume', nameEn: 'Shelmet', slug: 'shelmet', type: 'bug', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Polarhume', nameEn: 'Cubchoo', slug: 'cubchoo', type: 'ice', baseHp: 62, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Carolina',
          nameEn: 'Skyla',
          slug: 'skyla',
          types: ['flying'],
          team: [
            { nameFr: 'Déflaisan', nameEn: 'Unfezant', slug: 'unfezant', level: 32 },
            { nameFr: 'Rhinolove', nameEn: 'Swoobat', slug: 'swoobat', level: 33 },
            { nameFr: 'Lakmécygne', nameEn: 'Swanna', slug: 'swanna', level: 34 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 7,
        nameFr: 'Champion — Zhu',
        nameEn: 'Gym Leader — Brycen',
        types: ['ice'],
        wild: [
          { nameFr: 'Polarhume', nameEn: 'Cubchoo', slug: 'cubchoo', type: 'ice', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Sorbébé', nameEn: 'Vanillite', slug: 'vanillite', type: 'ice', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Hexagel', nameEn: 'Cryogonal', slug: 'cryogonal', type: 'ice', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Vivaldaim', nameEn: 'Deerling', slug: 'deerling', type: 'normal', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Larveyette', nameEn: 'Sewaddle', slug: 'sewaddle', type: 'bug', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Anchwatt', nameEn: 'Tynamo', slug: 'tynamo', type: 'electric', baseHp: 62, baseAtk: 14 },
        ],
        boss: {
          nameFr: 'Zhu',
          nameEn: 'Brycen',
          slug: 'brycen',
          types: ['ice'],
          team: [
            { nameFr: 'Polagriffe', nameEn: 'Beartic', slug: 'beartic', level: 36 },
            { nameFr: 'Sorbouboul', nameEn: 'Vanilluxe', slug: 'vanilluxe', level: 37 },
            { nameFr: 'Hexagel', nameEn: 'Cryogonal', slug: 'cryogonal', level: 38 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 8,
        nameFr: 'Championne — Iris',
        nameEn: 'Gym Leader — Iris',
        types: ['dragon'],
        wild: [
          { nameFr: 'Coupenotte', nameEn: 'Axew', slug: 'axew', type: 'dragon', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Solochi', nameEn: 'Deino', slug: 'deino', type: 'dark', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Drakkarmin', nameEn: 'Druddigon', slug: 'druddigon', type: 'dragon', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Incisache', nameEn: 'Fraxure', slug: 'fraxure', type: 'dragon', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Doudouvet', nameEn: 'Cottonee', slug: 'cottonee', type: 'grass', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Statitik', nameEn: 'Joltik', slug: 'joltik', type: 'bug', baseHp: 66, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Iris',
          nameEn: 'Iris',
          slug: 'iris',
          types: ['dragon'],
          team: [
            { nameFr: 'Drakkarmin', nameEn: 'Druddigon', slug: 'druddigon', level: 40 },
            { nameFr: 'Tranchodon', nameEn: 'Haxorus', slug: 'haxorus', level: 42 },
            { nameFr: 'Trioxhydre', nameEn: 'Hydreigon', slug: 'hydreigon', level: 44 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 9,
        nameFr: 'Conseil 4 — Anis',
        nameEn: 'Elite Four — Shauntal',
        types: ['ghost'],
        wild: [
          { nameFr: 'Tutafeh', nameEn: 'Yamask', slug: 'yamask', type: 'ghost', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Funécire', nameEn: 'Litwick', slug: 'litwick', type: 'ghost', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Viskuse', nameEn: 'Frillish', slug: 'frillish', type: 'water', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Gringolem', nameEn: 'Golett', slug: 'golett', type: 'ground', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Chlorobule', nameEn: 'Petilil', slug: 'petilil', type: 'grass', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Emolga', nameEn: 'Emolga', slug: 'emolga', type: 'electric', baseHp: 67, baseAtk: 15 },
          { nameFr: 'Poichigeon', nameEn: 'Pidove', slug: 'pidove', type: 'normal', baseHp: 67, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Anis',
          nameEn: 'Shauntal',
          slug: 'shauntal',
          types: ['ghost'],
          team: [
            { nameFr: 'Tutankafer', nameEn: 'Cofagrigus', slug: 'cofagrigus', level: 48 },
            { nameFr: 'Moyade', nameEn: 'Jellicent', slug: 'jellicent', level: 49 },
            { nameFr: 'Golemastoc', nameEn: 'Golurk', slug: 'golurk', level: 50 },
            { nameFr: 'Lugulabre', nameEn: 'Chandelure', slug: 'chandelure', level: 51 },
            { nameFr: 'Mélancolux', nameEn: 'Lampent', slug: 'lampent', level: 48 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 10,
        nameFr: 'Conseil 4 — Kunz',
        nameEn: 'Elite Four — Marshal',
        types: ['fighting'],
        wild: [
          { nameFr: 'Charpenti', nameEn: 'Timburr', slug: 'timburr', type: 'fighting', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Judokrak', nameEn: 'Throh', slug: 'throh', type: 'fighting', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Karaclée', nameEn: 'Sawk', slug: 'sawk', type: 'fighting', baseHp: 68, baseAtk: 16 },
          { nameFr: 'Kungfouine', nameEn: 'Mienfoo', slug: 'mienfoo', type: 'fighting', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Ratentif', nameEn: 'Patrat', slug: 'patrat', type: 'normal', baseHp: 67, baseAtk: 16 },
          { nameFr: 'Mascaïman', nameEn: 'Sandile', slug: 'sandile', type: 'ground', baseHp: 68, baseAtk: 16 },
        ],
        boss: {
          nameFr: 'Kunz',
          nameEn: 'Marshal',
          slug: 'marshal',
          types: ['fighting'],
          team: [
            { nameFr: 'Bétochef', nameEn: 'Conkeldurr', slug: 'conkeldurr', level: 49 },
            { nameFr: 'Judokrak', nameEn: 'Throh', slug: 'throh', level: 50 },
            { nameFr: 'Karaclée', nameEn: 'Sawk', slug: 'sawk', level: 50 },
            { nameFr: 'Shaofouine', nameEn: 'Mienshao', slug: 'mienshao', level: 51 },
            { nameFr: 'Baggaïd', nameEn: 'Scrafty', slug: 'scrafty', level: 52 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 11,
        nameFr: 'Conseil 4 — Percila',
        nameEn: 'Elite Four — Caitlin',
        types: ['psychic'],
        wild: [
          { nameFr: 'Munna', nameEn: 'Munna', slug: 'munna', type: 'psychic', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Scrutella', nameEn: 'Gothita', slug: 'gothita', type: 'psychic', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Nucléos', nameEn: 'Solosis', slug: 'solosis', type: 'psychic', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Lewsor', nameEn: 'Elgyem', slug: 'elgyem', type: 'psychic', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Nanméouïe', nameEn: 'Audino', slug: 'audino', type: 'normal', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Rototaupe', nameEn: 'Drilbur', slug: 'drilbur', type: 'ground', baseHp: 66, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Percila',
          nameEn: 'Caitlin',
          slug: 'caitlin',
          types: ['psychic'],
          team: [
            { nameFr: 'Mushana', nameEn: 'Musharna', slug: 'musharna', level: 50 },
            { nameFr: 'Sidérella', nameEn: 'Gothitelle', slug: 'gothitelle', level: 51 },
            { nameFr: 'Symbios', nameEn: 'Reuniclus', slug: 'reuniclus', level: 52 },
            { nameFr: 'Neitram', nameEn: 'Beheeyem', slug: 'beheeyem', level: 51 },
            { nameFr: 'Cryptéro', nameEn: 'Sigilyph', slug: 'sigilyph', level: 53 },
          ],
          timerSeconds: 35,
        },
      },
      {
        id: 12,
        nameFr: 'Conseil 4 — Pieris',
        nameEn: 'Elite Four — Grimsley',
        types: ['dark'],
        wild: [
          { nameFr: 'Limonde', nameEn: 'Stunfisk', slug: 'stunfisk', type: 'ground', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Baggiguane', nameEn: 'Scraggy', slug: 'scraggy', type: 'dark', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Zorua', nameEn: 'Zorua', slug: 'zorua', type: 'dark', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Vostourno', nameEn: 'Vullaby', slug: 'vullaby', type: 'dark', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Chinchidou', nameEn: 'Minccino', slug: 'minccino', type: 'normal', baseHp: 69, baseAtk: 15 },
          { nameFr: 'Chovsourir', nameEn: 'Woobat', slug: 'woobat', type: 'psychic', baseHp: 69, baseAtk: 15 },
          { nameFr: 'Flotajou', nameEn: 'Panpour', slug: 'panpour', type: 'water', baseHp: 68, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Pieris',
          nameEn: 'Grimsley',
          slug: 'grimsley',
          types: ['dark'],
          team: [
            { nameFr: 'Léopardus', nameEn: 'Liepard', slug: 'liepard', level: 51 },
            { nameFr: 'Zoroark', nameEn: 'Zoroark', slug: 'zoroark', level: 52 },
            { nameFr: 'Baggaïd', nameEn: 'Scrafty', slug: 'scrafty', level: 52 },
            { nameFr: 'Scalproie', nameEn: 'Bisharp', slug: 'bisharp', level: 53 },
            { nameFr: 'Vaututrice', nameEn: 'Mandibuzz', slug: 'mandibuzz', level: 54 },
          ],
          timerSeconds: 40,
        },
      },
      {
        id: 13,
        nameFr: 'Maître — Goyah',
        nameEn: 'Champion — Alder',
        types: ['fire', 'bug', 'rock'],
        wild: [
          { nameFr: 'Pyronille', nameEn: 'Larvesta', slug: 'larvesta', type: 'bug', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Darumarond', nameEn: 'Darumaka', slug: 'darumaka', type: 'fire', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Aflamanoir', nameEn: 'Heatmor', slug: 'heatmor', type: 'fire', baseHp: 74, baseAtk: 17 },
          { nameFr: 'Fermite', nameEn: 'Durant', slug: 'durant', type: 'bug', baseHp: 72, baseAtk: 17 },
          { nameFr: 'Venipatte', nameEn: 'Venipede', slug: 'venipede', type: 'bug', baseHp: 71, baseAtk: 17 },
          { nameFr: 'Tritonde', nameEn: 'Tympole', slug: 'tympole', type: 'water', baseHp: 71, baseAtk: 17 },
        ],
        boss: {
          nameFr: 'Goyah',
          nameEn: 'Alder',
          slug: 'alder',
          types: ['fire', 'bug'],
          team: [
            { nameFr: 'Darumacho', nameEn: 'Darmanitan', slug: 'darmanitan', level: 54 },
            { nameFr: 'Gueriaigle', nameEn: 'Braviary', slug: 'braviary', level: 54 },
            { nameFr: 'Minotaupe', nameEn: 'Excadrill', slug: 'excadrill', level: 55 },
            { nameFr: 'Noacier', nameEn: 'Ferrothorn', slug: 'ferrothorn', level: 56 },
            { nameFr: 'Frison', nameEn: 'Bouffalant', slug: 'bouffalant', level: 57 },
            { nameFr: 'Pyrax', nameEn: 'Volcarona', slug: 'volcarona', level: 60 },
          ],
          timerSeconds: 45,
        },
      },
    ],
  },
  // ══════════════════════════════════════════════════
  // Generation 6 — Kalos
  // ══════════════════════════════════════════════════
  {
    id: 6,
    nameFr: 'Génération VI',
    nameEn: 'Generation VI',
    regionFr: 'Kalos',
    regionEn: 'Kalos',
    zones: [
      {
        id: 1,
        nameFr: 'Championne — Violette',
        nameEn: 'Gym Leader — Viola',
        types: ['bug'],
        wild: [
          { nameFr: 'Lépidonille', nameEn: 'Scatterbug', slug: 'scatterbug', type: 'bug', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Pérégrain', nameEn: 'Spewpa', slug: 'spewpa', type: 'bug', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Passerouge', nameEn: 'Fletchling', slug: 'fletchling', type: 'normal', baseHp: 52, baseAtk: 10 },
          { nameFr: 'Sapereau', nameEn: 'Bunnelby', slug: 'bunnelby', type: 'normal', baseHp: 48, baseAtk: 9 },
          { nameFr: 'Hélionceau', nameEn: 'Litleo', slug: 'litleo', type: 'fire', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Cabriolaine', nameEn: 'Skiddo', slug: 'skiddo', type: 'grass', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Couafarel', nameEn: 'Furfrou', slug: 'furfrou', type: 'normal', baseHp: 51, baseAtk: 10 },
        ],
        boss: {
          nameFr: 'Violette',
          nameEn: 'Viola',
          slug: 'viola',
          types: ['bug'],
          team: [
            { nameFr: 'Prismillon', nameEn: 'Vivillon', slug: 'vivillon', level: 12 },
            { nameFr: 'Pérégrain', nameEn: 'Spewpa', slug: 'spewpa', level: 13 },
            { nameFr: 'Lépidonille', nameEn: 'Scatterbug', slug: 'scatterbug', level: 14 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 2,
        nameFr: 'Champion — Lino',
        nameEn: 'Gym Leader — Grant',
        types: ['rock'],
        wild: [
          { nameFr: 'Opermine', nameEn: 'Binacle', slug: 'binacle', type: 'rock', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Ptyranidur', nameEn: 'Tyrunt', slug: 'tyrunt', type: 'rock', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Amagara', nameEn: 'Amaura', slug: 'amaura', type: 'rock', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Couafarel', nameEn: 'Furfrou', slug: 'furfrou', type: 'normal', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Monorpale', nameEn: 'Honedge', slug: 'honedge', type: 'steel', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Sapereau', nameEn: 'Bunnelby', slug: 'bunnelby', type: 'normal', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Hélionceau', nameEn: 'Litleo', slug: 'litleo', type: 'fire', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Cabriolaine', nameEn: 'Skiddo', slug: 'skiddo', type: 'grass', baseHp: 56, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Lino',
          nameEn: 'Grant',
          slug: 'grant',
          types: ['rock'],
          team: [
            { nameFr: 'Rexillius', nameEn: 'Tyrantrum', slug: 'tyrantrum', level: 16 },
            { nameFr: 'Dragmara', nameEn: 'Aurorus', slug: 'aurorus', level: 17 },
            { nameFr: 'Golgopathe', nameEn: 'Barbaracle', slug: 'barbaracle', level: 18 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 3,
        nameFr: 'Championne — Cornélia',
        nameEn: 'Gym Leader — Korrina',
        types: ['fighting'],
        wild: [
          { nameFr: 'Pandespiègle', nameEn: 'Pancham', slug: 'pancham', type: 'fighting', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Brutalibré', nameEn: 'Hawlucha', slug: 'hawlucha', type: 'fighting', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Sapereau', nameEn: 'Bunnelby', slug: 'bunnelby', type: 'normal', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Hélionceau', nameEn: 'Litleo', slug: 'litleo', type: 'fire', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Couafarel', nameEn: 'Furfrou', slug: 'furfrou', type: 'normal', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Cabriolaine', nameEn: 'Skiddo', slug: 'skiddo', type: 'grass', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Psystigri', nameEn: 'Espurr', slug: 'espurr', type: 'psychic', baseHp: 59, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Cornélia',
          nameEn: 'Korrina',
          slug: 'korrina',
          types: ['fighting'],
          team: [
            { nameFr: 'Pandarbare', nameEn: 'Pangoro', slug: 'pangoro', level: 20 },
            { nameFr: 'Brutalibré', nameEn: 'Hawlucha', slug: 'hawlucha', level: 21 },
            { nameFr: 'Blindépique', nameEn: 'Chesnaught', slug: 'chesnaught', level: 22 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 4,
        nameFr: 'Champion — Amaro',
        nameEn: 'Gym Leader — Ramos',
        types: ['grass'],
        wild: [
          { nameFr: 'Opermine', nameEn: 'Binacle', slug: 'binacle', type: 'rock', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Flabébé', nameEn: 'Flabébé', slug: 'flabebe', type: 'fairy', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Brocélôme', nameEn: 'Phantump', slug: 'phantump', type: 'ghost', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Psystigri', nameEn: 'Espurr', slug: 'espurr', type: 'psychic', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Dedenne', nameEn: 'Dedenne', slug: 'dedenne', type: 'electric', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Marisson', nameEn: 'Chespin', slug: 'chespin', type: 'grass', baseHp: 57, baseAtk: 12 },
          { nameFr: 'Fluvetin', nameEn: 'Spritzee', slug: 'spritzee', type: 'fairy', baseHp: 57, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Amaro',
          nameEn: 'Ramos',
          slug: 'ramos',
          types: ['grass'],
          team: [
            { nameFr: 'Chevroum', nameEn: 'Gogoat', slug: 'gogoat', level: 25 },
            { nameFr: 'Desséliande', nameEn: 'Trevenant', slug: 'trevenant', level: 26 },
            { nameFr: 'Florges', nameEn: 'Florges', slug: 'florges', level: 27 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 5,
        nameFr: 'Champion — Lem',
        nameEn: 'Gym Leader — Clemont',
        types: ['electric'],
        wild: [
          { nameFr: 'Galvaran', nameEn: 'Helioptile', slug: 'helioptile', type: 'electric', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Dedenne', nameEn: 'Dedenne', slug: 'dedenne', type: 'electric', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Sucroquin', nameEn: 'Swirlix', slug: 'swirlix', type: 'fairy', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Sepiatop', nameEn: 'Inkay', slug: 'inkay', type: 'dark', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Ptyranidur', nameEn: 'Tyrunt', slug: 'tyrunt', type: 'rock', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Feunnec', nameEn: 'Fennekin', slug: 'fennekin', type: 'fire', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Brocélôme', nameEn: 'Phantump', slug: 'phantump', type: 'ghost', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Psystigri', nameEn: 'Espurr', slug: 'espurr', type: 'psychic', baseHp: 59, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Lem',
          nameEn: 'Clemont',
          slug: 'clemont',
          types: ['electric'],
          team: [
            { nameFr: 'Iguolta', nameEn: 'Heliolisk', slug: 'heliolisk', level: 29 },
            { nameFr: 'Dedenne', nameEn: 'Dedenne', slug: 'dedenne', level: 30 },
            { nameFr: 'Némélios', nameEn: 'Pyroar', slug: 'pyroar', level: 31 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 6,
        nameFr: 'Championne — Valériane',
        nameEn: 'Gym Leader — Valerie',
        types: ['fairy'],
        wild: [
          { nameFr: 'Fluvetin', nameEn: 'Spritzee', slug: 'spritzee', type: 'fairy', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Sucroquin', nameEn: 'Swirlix', slug: 'swirlix', type: 'fairy', baseHp: 60, baseAtk: 12 },
          { nameFr: 'Trousselin', nameEn: 'Klefki', slug: 'klefki', type: 'steel', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Flabébé', nameEn: 'Flabébé', slug: 'flabebe', type: 'fairy', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Galvaran', nameEn: 'Helioptile', slug: 'helioptile', type: 'electric', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Grenousse', nameEn: 'Froakie', slug: 'froakie', type: 'water', baseHp: 61, baseAtk: 13 },
          { nameFr: 'Pitrouille', nameEn: 'Pumpkaboo', slug: 'pumpkaboo', type: 'ghost', baseHp: 61, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Valériane',
          nameEn: 'Valerie',
          slug: 'valerie',
          types: ['fairy'],
          team: [
            { nameFr: 'Cocotine', nameEn: 'Aromatisse', slug: 'aromatisse', level: 33 },
            { nameFr: 'Cupcanaille', nameEn: 'Slurpuff', slug: 'slurpuff', level: 34 },
            { nameFr: 'Trousselin', nameEn: 'Klefki', slug: 'klefki', level: 35 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 7,
        nameFr: 'Championne — Astera',
        nameEn: 'Gym Leader — Olympia',
        types: ['psychic'],
        wild: [
          { nameFr: 'Sucroquin', nameEn: 'Swirlix', slug: 'swirlix', type: 'fairy', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Sepiatop', nameEn: 'Inkay', slug: 'inkay', type: 'dark', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Strassie', nameEn: 'Carbink', slug: 'carbink', type: 'rock', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Monorpale', nameEn: 'Honedge', slug: 'honedge', type: 'steel', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Brocélôme', nameEn: 'Phantump', slug: 'phantump', type: 'ghost', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Lépidonille', nameEn: 'Scatterbug', slug: 'scatterbug', type: 'bug', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Braisillon', nameEn: 'Fletchinder', slug: 'fletchinder', type: 'fire', baseHp: 63, baseAtk: 14 },
        ],
        boss: {
          nameFr: 'Astera',
          nameEn: 'Olympia',
          slug: 'olympia',
          types: ['psychic'],
          team: [
            { nameFr: 'Mistigrix', nameEn: 'Meowstic', slug: 'meowstic', level: 37 },
            { nameFr: 'Sepiatroce', nameEn: 'Malamar', slug: 'malamar', level: 38 },
            { nameFr: 'Strassie', nameEn: 'Carbink', slug: 'carbink', level: 39 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 8,
        nameFr: 'Champion — Urup',
        nameEn: 'Gym Leader — Wulfric',
        types: ['ice'],
        wild: [
          { nameFr: 'Grelaçon', nameEn: 'Bergmite', slug: 'bergmite', type: 'ice', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Pitrouille', nameEn: 'Pumpkaboo', slug: 'pumpkaboo', type: 'ghost', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Sonistrelle', nameEn: 'Noibat', slug: 'noibat', type: 'flying', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Venalgue', nameEn: 'Skrelp', slug: 'skrelp', type: 'poison', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Flingouste', nameEn: 'Clauncher', slug: 'clauncher', type: 'water', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Pérégrain', nameEn: 'Spewpa', slug: 'spewpa', type: 'bug', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Marisson', nameEn: 'Chespin', slug: 'chespin', type: 'grass', baseHp: 63, baseAtk: 14 },
          { nameFr: 'Amagara', nameEn: 'Amaura', slug: 'amaura', type: 'rock', baseHp: 63, baseAtk: 14 },
        ],
        boss: {
          nameFr: 'Urup',
          nameEn: 'Wulfric',
          slug: 'wulfric',
          types: ['ice'],
          team: [
            { nameFr: 'Séracrawl', nameEn: 'Avalugg', slug: 'avalugg', level: 41 },
            { nameFr: 'Banshitrouye', nameEn: 'Gourgeist', slug: 'gourgeist', level: 42 },
            { nameFr: 'Bruyverne', nameEn: 'Noivern', slug: 'noivern', level: 43 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 9,
        nameFr: 'Conseil 4 — Malva',
        nameEn: 'Elite Four — Malva',
        types: ['fire'],
        wild: [
          { nameFr: 'Braisillon', nameEn: 'Fletchinder', slug: 'fletchinder', type: 'fire', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Feunnec', nameEn: 'Fennekin', slug: 'fennekin', type: 'fire', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Venalgue', nameEn: 'Skrelp', slug: 'skrelp', type: 'poison', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Pandespiègle', nameEn: 'Pancham', slug: 'pancham', type: 'fighting', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Dedenne', nameEn: 'Dedenne', slug: 'dedenne', type: 'electric', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Passerouge', nameEn: 'Fletchling', slug: 'fletchling', type: 'normal', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Brutalibré', nameEn: 'Hawlucha', slug: 'hawlucha', type: 'fighting', baseHp: 65, baseAtk: 14 },
        ],
        boss: {
          nameFr: 'Malva',
          nameEn: 'Malva',
          slug: 'malva',
          types: ['fire'],
          team: [
            { nameFr: 'Flambusard', nameEn: 'Talonflame', slug: 'talonflame', level: 46 },
            { nameFr: 'Némélios', nameEn: 'Pyroar', slug: 'pyroar', level: 47 },
            { nameFr: 'Goupelin', nameEn: 'Delphox', slug: 'delphox', level: 48 },
            { nameFr: 'Kravarech', nameEn: 'Dragalge', slug: 'dragalge', level: 49 },
            { nameFr: 'Braisillon', nameEn: 'Fletchinder', slug: 'fletchinder', level: 46 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 10,
        nameFr: 'Conseil 4 — Narcisse',
        nameEn: 'Elite Four — Siebold',
        types: ['water'],
        wild: [
          { nameFr: 'Flingouste', nameEn: 'Clauncher', slug: 'clauncher', type: 'water', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Opermine', nameEn: 'Binacle', slug: 'binacle', type: 'rock', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Venalgue', nameEn: 'Skrelp', slug: 'skrelp', type: 'poison', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Mucuscule', nameEn: 'Goomy', slug: 'goomy', type: 'dragon', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Sepiatop', nameEn: 'Inkay', slug: 'inkay', type: 'dark', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Ptyranidur', nameEn: 'Tyrunt', slug: 'tyrunt', type: 'rock', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Grenousse', nameEn: 'Froakie', slug: 'froakie', type: 'water', baseHp: 67, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Narcisse',
          nameEn: 'Siebold',
          slug: 'siebold',
          types: ['water'],
          team: [
            { nameFr: 'Gamblast', nameEn: 'Clawitzer', slug: 'clawitzer', level: 48 },
            { nameFr: 'Golgopathe', nameEn: 'Barbaracle', slug: 'barbaracle', level: 49 },
            { nameFr: 'Kravarech', nameEn: 'Dragalge', slug: 'dragalge', level: 50 },
            { nameFr: 'Amphinobi', nameEn: 'Greninja', slug: 'greninja', level: 51 },
            { nameFr: 'Gamblast', nameEn: 'Clawitzer', slug: 'clawitzer', level: 48 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 11,
        nameFr: 'Conseil 4 — Thyméo',
        nameEn: 'Elite Four — Wikstrom',
        types: ['steel'],
        wild: [
          { nameFr: 'Monorpale', nameEn: 'Honedge', slug: 'honedge', type: 'steel', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Trousselin', nameEn: 'Klefki', slug: 'klefki', type: 'steel', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Dimoclès', nameEn: 'Doublade', slug: 'doublade', type: 'steel', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Grelaçon', nameEn: 'Bergmite', slug: 'bergmite', type: 'ice', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Strassie', nameEn: 'Carbink', slug: 'carbink', type: 'rock', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Amagara', nameEn: 'Amaura', slug: 'amaura', type: 'rock', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Lépidonille', nameEn: 'Scatterbug', slug: 'scatterbug', type: 'bug', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Pandespiègle', nameEn: 'Pancham', slug: 'pancham', type: 'fighting', baseHp: 70, baseAtk: 16 },
        ],
        boss: {
          nameFr: 'Thyméo',
          nameEn: 'Wikstrom',
          slug: 'wikstrom',
          types: ['steel'],
          team: [
            { nameFr: 'Exagide', nameEn: 'Aegislash', slug: 'aegislash', level: 50 },
            { nameFr: 'Trousselin', nameEn: 'Klefki', slug: 'klefki', level: 51 },
            { nameFr: 'Dimoclès', nameEn: 'Doublade', slug: 'doublade', level: 51 },
            { nameFr: 'Blindépique', nameEn: 'Chesnaught', slug: 'chesnaught', level: 52 },
            { nameFr: 'Exagide', nameEn: 'Aegislash', slug: 'aegislash', level: 50 },
          ],
          timerSeconds: 35,
        },
      },
      {
        id: 12,
        nameFr: 'Conseil 4 — Dracéna',
        nameEn: 'Elite Four — Drasna',
        types: ['dragon'],
        wild: [
          { nameFr: 'Mucuscule', nameEn: 'Goomy', slug: 'goomy', type: 'dragon', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Colimucus', nameEn: 'Sliggoo', slug: 'sliggoo', type: 'dragon', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Sonistrelle', nameEn: 'Noibat', slug: 'noibat', type: 'flying', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Flingouste', nameEn: 'Clauncher', slug: 'clauncher', type: 'water', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Grelaçon', nameEn: 'Bergmite', slug: 'bergmite', type: 'ice', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Brutalibré', nameEn: 'Hawlucha', slug: 'hawlucha', type: 'fighting', baseHp: 68, baseAtk: 16 },
          { nameFr: 'Pérégrain', nameEn: 'Spewpa', slug: 'spewpa', type: 'bug', baseHp: 68, baseAtk: 16 },
        ],
        boss: {
          nameFr: 'Dracéna',
          nameEn: 'Drasna',
          slug: 'drasna',
          types: ['dragon'],
          team: [
            { nameFr: 'Muplodocus', nameEn: 'Goodra', slug: 'goodra', level: 52 },
            { nameFr: 'Bruyverne', nameEn: 'Noivern', slug: 'noivern', level: 53 },
            { nameFr: 'Colimucus', nameEn: 'Sliggoo', slug: 'sliggoo', level: 52 },
            { nameFr: 'Kravarech', nameEn: 'Dragalge', slug: 'dragalge', level: 53 },
            { nameFr: 'Rexillius', nameEn: 'Tyrantrum', slug: 'tyrantrum', level: 54 },
          ],
          timerSeconds: 40,
        },
      },
      {
        id: 13,
        nameFr: 'Maître — Dianthéa',
        nameEn: 'Champion — Diantha',
        types: ['fairy', 'rock', 'dragon'],
        wild: [
          { nameFr: 'Colimucus', nameEn: 'Sliggoo', slug: 'sliggoo', type: 'dragon', baseHp: 74, baseAtk: 17 },
          { nameFr: 'Dimoclès', nameEn: 'Doublade', slug: 'doublade', type: 'steel', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Fluvetin', nameEn: 'Spritzee', slug: 'spritzee', type: 'fairy', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Sonistrelle', nameEn: 'Noibat', slug: 'noibat', type: 'flying', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Flabébé', nameEn: 'Flabébé', slug: 'flabebe', type: 'fairy', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Galvaran', nameEn: 'Helioptile', slug: 'helioptile', type: 'electric', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Passerouge', nameEn: 'Fletchling', slug: 'fletchling', type: 'normal', baseHp: 70, baseAtk: 16 },
        ],
        boss: {
          nameFr: 'Dianthéa',
          nameEn: 'Diantha',
          slug: 'diantha',
          types: ['rock', 'fairy'],
          team: [
            { nameFr: 'Florges', nameEn: 'Florges', slug: 'florges', level: 55 },
            { nameFr: 'Muplodocus', nameEn: 'Goodra', slug: 'goodra', level: 55 },
            { nameFr: 'Flambusard', nameEn: 'Talonflame', slug: 'talonflame', level: 56 },
            { nameFr: 'Exagide', nameEn: 'Aegislash', slug: 'aegislash', level: 57 },
            { nameFr: 'Amphinobi', nameEn: 'Greninja', slug: 'greninja', level: 58 },
            { nameFr: 'Méga-Diancie', nameEn: 'Mega Diancie', slug: 'diancie-mega', level: 60 },
          ],
          timerSeconds: 45,
        },
      },
    ],
  },
  // ══════════════════════════════════════════════════
  // Gen 7 — Alola
  // ══════════════════════════════════════════════════
  {
    id: 7,
    nameFr: 'Génération VII',
    nameEn: 'Generation VII',
    regionFr: 'Alola',
    regionEn: 'Alola',
    zones: [
      {
        id: 1,
        nameFr: 'Capitaine — Althéo',
        nameEn: 'Trial Captain — Ilima',
        types: ['normal'],
        wild: [
          { nameFr: 'Manglouton', nameEn: 'Yungoos', slug: 'yungoos', type: 'normal', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Rattata (Alola)', nameEn: 'Rattata (Alola)', slug: 'rattata-alola', type: 'dark', baseHp: 48, baseAtk: 10 },
          { nameFr: 'Picassaut', nameEn: 'Pikipek', slug: 'pikipek', type: 'normal', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Brindibou', nameEn: 'Rowlet', slug: 'rowlet', type: 'grass', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Flamiaou', nameEn: 'Litten', slug: 'litten', type: 'fire', baseHp: 48, baseAtk: 10 },
          { nameFr: 'Larvibule', nameEn: 'Grubbin', slug: 'grubbin', type: 'bug', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Plumeline', nameEn: 'Oricorio', slug: 'oricorio', type: 'fire', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Bombydou', nameEn: 'Cutiefly', slug: 'cutiefly', type: 'fairy', baseHp: 49, baseAtk: 10 },
        ],
        boss: {
          nameFr: 'Althéo',
          nameEn: 'Ilima',
          slug: 'ilima',
          types: ['normal'],
          team: [
            { nameFr: 'Argouste', nameEn: 'Gumshoos', slug: 'gumshoos', level: 12 },
            { nameFr: 'Rattatac (Alola)', nameEn: 'Raticate (Alola)', slug: 'raticate-alola', level: 13 },
            { nameFr: 'Dodoala', nameEn: 'Komala', slug: 'komala', level: 14 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 2,
        nameFr: 'Doyen — Pectorius',
        nameEn: 'Kahuna — Hala',
        types: ['fighting'],
        wild: [
          { nameFr: 'Crabagarre', nameEn: 'Crabrawler', slug: 'crabrawler', type: 'fighting', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Manglouton', nameEn: 'Yungoos', slug: 'yungoos', type: 'normal', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Nounourson', nameEn: 'Stufful', slug: 'stufful', type: 'normal', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Otaquin', nameEn: 'Popplio', slug: 'popplio', type: 'water', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Dodoala', nameEn: 'Komala', slug: 'komala', type: 'normal', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Picassaut', nameEn: 'Pikipek', slug: 'pikipek', type: 'normal', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Larvibule', nameEn: 'Grubbin', slug: 'grubbin', type: 'bug', baseHp: 52, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Pectorius',
          nameEn: 'Hala',
          slug: 'hala',
          types: ['fighting'],
          team: [
            { nameFr: 'Crabominable', nameEn: 'Crabominable', slug: 'crabominable', level: 16 },
            { nameFr: 'Chelours', nameEn: 'Bewear', slug: 'bewear', level: 17 },
            { nameFr: 'Quartermac', nameEn: 'Passimian', slug: 'passimian', level: 18 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 3,
        nameFr: 'Capitaine — Néphie',
        nameEn: 'Trial Captain — Lana',
        types: ['water'],
        wild: [
          { nameFr: 'Froussardine', nameEn: 'Wishiwashi', slug: 'wishiwashi', type: 'water', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Vorastérie', nameEn: 'Mareanie', slug: 'mareanie', type: 'poison', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Araqua', nameEn: 'Dewpider', slug: 'dewpider', type: 'water', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Concombaffe', nameEn: 'Pyukumuku', slug: 'pyukumuku', type: 'water', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Otaquin', nameEn: 'Popplio', slug: 'popplio', type: 'water', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Picassaut', nameEn: 'Pikipek', slug: 'pikipek', type: 'normal', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Manglouton', nameEn: 'Yungoos', slug: 'yungoos', type: 'normal', baseHp: 52, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Néphie',
          nameEn: 'Lana',
          slug: 'lana',
          types: ['water'],
          team: [
            { nameFr: 'Prédastérie', nameEn: 'Toxapex', slug: 'toxapex', level: 20 },
            { nameFr: 'Tarenbulle', nameEn: 'Araquanid', slug: 'araquanid', level: 21 },
            { nameFr: 'Froussardine', nameEn: 'Wishiwashi', slug: 'wishiwashi', level: 22 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 4,
        nameFr: 'Capitaine — Kiawe',
        nameEn: 'Trial Captain — Kiawe',
        types: ['fire'],
        wild: [
          { nameFr: 'Tritox', nameEn: 'Salandit', slug: 'salandit', type: 'poison', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Ossatueur (Alola)', nameEn: 'Marowak (Alola)', slug: 'marowak-alola', type: 'fire', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Boumata', nameEn: 'Turtonator', slug: 'turtonator', type: 'fire', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Flamiaou', nameEn: 'Litten', slug: 'litten', type: 'fire', baseHp: 54, baseAtk: 12 },
          { nameFr: 'Plumeline', nameEn: 'Oricorio', slug: 'oricorio', type: 'fire', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Croquine', nameEn: 'Bounsweet', slug: 'bounsweet', type: 'grass', baseHp: 56, baseAtk: 13 },
          { nameFr: 'Goupix (Alola)', nameEn: 'Vulpix (Alola)', slug: 'vulpix-alola', type: 'ice', baseHp: 57, baseAtk: 13 },
          { nameFr: 'Larvibule', nameEn: 'Grubbin', slug: 'grubbin', type: 'bug', baseHp: 56, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Kiawe',
          nameEn: 'Kiawe',
          slug: 'kiawe',
          types: ['fire'],
          team: [
            { nameFr: 'Malamandre', nameEn: 'Salazzle', slug: 'salazzle', level: 24 },
            { nameFr: 'Ossatueur (Alola)', nameEn: 'Marowak (Alola)', slug: 'marowak-alola', level: 25 },
            { nameFr: 'Boumata', nameEn: 'Turtonator', slug: 'turtonator', level: 26 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 5,
        nameFr: 'Capitaine — Barbara',
        nameEn: 'Trial Captain — Mallow',
        types: ['grass'],
        wild: [
          { nameFr: 'Mimantis', nameEn: 'Fomantis', slug: 'fomantis', type: 'grass', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Spododo', nameEn: 'Morelull', slug: 'morelull', type: 'grass', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Croquine', nameEn: 'Bounsweet', slug: 'bounsweet', type: 'grass', baseHp: 54, baseAtk: 12 },
          { nameFr: 'Brindibou', nameEn: 'Rowlet', slug: 'rowlet', type: 'grass', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Guérilande', nameEn: 'Comfey', slug: 'comfey', type: 'fairy', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Météno', nameEn: 'Minior', slug: 'minior', type: 'rock', baseHp: 55, baseAtk: 12 },
          { nameFr: 'Sabelette (Alola)', nameEn: 'Sandshrew (Alola)', slug: 'sandshrew-alola', type: 'ice', baseHp: 55, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Barbara',
          nameEn: 'Mallow',
          slug: 'mallow',
          types: ['grass'],
          team: [
            { nameFr: 'Floramantis', nameEn: 'Lurantis', slug: 'lurantis', level: 28 },
            { nameFr: 'Lampignon', nameEn: 'Shiinotic', slug: 'shiinotic', level: 29 },
            { nameFr: 'Sucreine', nameEn: 'Tsareena', slug: 'tsareena', level: 30 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 6,
        nameFr: 'Doyenne — Alyxia',
        nameEn: 'Kahuna — Olivia',
        types: ['rock'],
        wild: [
          { nameFr: 'Rocabot', nameEn: 'Rockruff', slug: 'rockruff', type: 'rock', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Météno', nameEn: 'Minior', slug: 'minior', type: 'rock', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Racaillou (Alola)', nameEn: 'Geodude (Alola)', slug: 'geodude-alola', type: 'rock', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Tiboudet', nameEn: 'Mudbray', slug: 'mudbray', type: 'ground', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Nounourson', nameEn: 'Stufful', slug: 'stufful', type: 'normal', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Chrysapile', nameEn: 'Charjabug', slug: 'charjabug', type: 'bug', baseHp: 58, baseAtk: 13 },
          { nameFr: 'Rattata (Alola)', nameEn: 'Rattata (Alola)', slug: 'rattata-alola', type: 'dark', baseHp: 58, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Alyxia',
          nameEn: 'Olivia',
          slug: 'olivia',
          types: ['rock'],
          team: [
            { nameFr: 'Lougaroc', nameEn: 'Lycanroc', slug: 'lycanroc', level: 31 },
            { nameFr: 'Grolem (Alola)', nameEn: 'Golem (Alola)', slug: 'golem-alola', level: 32 },
            { nameFr: 'Météno', nameEn: 'Minior', slug: 'minior', level: 33 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 7,
        nameFr: 'Capitaine — Chrys',
        nameEn: 'Trial Captain — Sophocles',
        types: ['electric'],
        wild: [
          { nameFr: 'Trépassable', nameEn: 'Palossand', slug: 'palossand', type: 'ghost', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Chrysapile', nameEn: 'Charjabug', slug: 'charjabug', type: 'bug', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Togedemaru', nameEn: 'Togedemaru', slug: 'togedemaru', type: 'electric', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Plumeline', nameEn: 'Oricorio', slug: 'oricorio', type: 'fire', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Racaillou (Alola)', nameEn: 'Geodude (Alola)', slug: 'geodude-alola', type: 'rock', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Crabagarre', nameEn: 'Crabrawler', slug: 'crabrawler', type: 'fighting', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Bombydou', nameEn: 'Cutiefly', slug: 'cutiefly', type: 'fairy', baseHp: 61, baseAtk: 14 },
          { nameFr: 'Rocabot', nameEn: 'Rockruff', slug: 'rockruff', type: 'rock', baseHp: 62, baseAtk: 14 },
        ],
        boss: {
          nameFr: 'Chrys',
          nameEn: 'Sophocles',
          slug: 'sophocles',
          types: ['electric'],
          team: [
            { nameFr: 'Lucanon', nameEn: 'Vikavolt', slug: 'vikavolt', level: 34 },
            { nameFr: 'Togedemaru', nameEn: 'Togedemaru', slug: 'togedemaru', level: 35 },
            { nameFr: 'Chrysapile', nameEn: 'Charjabug', slug: 'charjabug', level: 36 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 8,
        nameFr: 'Capitaine — Margie',
        nameEn: 'Trial Captain — Acerola',
        types: ['ghost'],
        wild: [
          { nameFr: 'Bacabouh', nameEn: 'Sandygast', slug: 'sandygast', type: 'ghost', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Mimiqui', nameEn: 'Mimikyu', slug: 'mimikyu', type: 'ghost', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Sinistrail', nameEn: 'Dhelmise', slug: 'dhelmise', type: 'ghost', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Bombydou', nameEn: 'Cutiefly', slug: 'cutiefly', type: 'bug', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Denticrisse', nameEn: 'Bruxish', slug: 'bruxish', type: 'water', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Togedemaru', nameEn: 'Togedemaru', slug: 'togedemaru', type: 'electric', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Froussardine', nameEn: 'Wishiwashi', slug: 'wishiwashi', type: 'water', baseHp: 64, baseAtk: 14 },
        ],
        boss: {
          nameFr: 'Margie',
          nameEn: 'Acerola',
          slug: 'acerola',
          types: ['ghost'],
          team: [
            { nameFr: 'Trépassable', nameEn: 'Palossand', slug: 'palossand', level: 37 },
            { nameFr: 'Mimiqui', nameEn: 'Mimikyu', slug: 'mimikyu', level: 38 },
            { nameFr: 'Sinistrail', nameEn: 'Dhelmise', slug: 'dhelmise', level: 39 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 9,
        nameFr: 'Doyen — Danh',
        nameEn: 'Kahuna — Nanu',
        types: ['dark'],
        wild: [
          { nameFr: 'Miaouss (Alola)', nameEn: 'Meowth (Alola)', slug: 'meowth-alola', type: 'dark', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Tadmorv (Alola)', nameEn: 'Grimer (Alola)', slug: 'grimer-alola', type: 'poison', baseHp: 64, baseAtk: 15 },
          { nameFr: 'Sovkipou', nameEn: 'Wimpod', slug: 'wimpod', type: 'bug', baseHp: 60, baseAtk: 14 },
          { nameFr: 'Tritox', nameEn: 'Salandit', slug: 'salandit', type: 'poison', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Tiboudet', nameEn: 'Mudbray', slug: 'mudbray', type: 'ground', baseHp: 64, baseAtk: 15 },
          { nameFr: 'Sinistrail', nameEn: 'Dhelmise', slug: 'dhelmise', type: 'ghost', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Vorastérie', nameEn: 'Mareanie', slug: 'mareanie', type: 'poison', baseHp: 62, baseAtk: 14 },
        ],
        boss: {
          nameFr: 'Danh',
          nameEn: 'Nanu',
          slug: 'nanu',
          types: ['dark'],
          team: [
            { nameFr: 'Persian (Alola)', nameEn: 'Persian (Alola)', slug: 'persian-alola', level: 40 },
            { nameFr: 'Grotadmorv (Alola)', nameEn: 'Muk (Alola)', slug: 'muk-alola', level: 41 },
            { nameFr: 'Sarmuraï', nameEn: 'Golisopod', slug: 'golisopod', level: 42 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 10,
        nameFr: 'Capitaine — Oléa',
        nameEn: 'Trial Captain — Mina',
        types: ['fairy'],
        wild: [
          { nameFr: 'Écaïd', nameEn: 'Hakamo-o', slug: 'hakamoo', type: 'dragon', baseHp: 64, baseAtk: 15 },
          { nameFr: 'Guérilande', nameEn: 'Comfey', slug: 'comfey', type: 'fairy', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Quartermac', nameEn: 'Passimian', slug: 'passimian', type: 'fighting', baseHp: 64, baseAtk: 15 },
          { nameFr: 'Spododo', nameEn: 'Morelull', slug: 'morelull', type: 'grass', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Nounourson', nameEn: 'Stufful', slug: 'stufful', type: 'normal', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Miaouss (Alola)', nameEn: 'Meowth (Alola)', slug: 'meowth-alola', type: 'dark', baseHp: 63, baseAtk: 15 },
          { nameFr: 'Araqua', nameEn: 'Dewpider', slug: 'dewpider', type: 'water', baseHp: 63, baseAtk: 15 },
          { nameFr: 'Draïeul', nameEn: 'Drampa', slug: 'drampa', type: 'normal', baseHp: 64, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Oléa',
          nameEn: 'Mina',
          slug: 'mina',
          types: ['fairy'],
          team: [
            { nameFr: 'Rubombelle', nameEn: 'Ribombee', slug: 'ribombee', level: 43 },
            { nameFr: 'Guérilande', nameEn: 'Comfey', slug: 'comfey', level: 44 },
            { nameFr: 'Feunard (Alola)', nameEn: 'Ninetales (Alola)', slug: 'ninetales-alola', level: 45 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 11,
        nameFr: 'Doyenne — Paulie',
        nameEn: 'Kahuna — Hapu',
        types: ['ground'],
        wild: [
          { nameFr: 'Tiboudet', nameEn: 'Mudbray', slug: 'mudbray', type: 'ground', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Taupiqueur (Alola)', nameEn: 'Diglett (Alola)', slug: 'diglett-alola', type: 'ground', baseHp: 64, baseAtk: 15 },
          { nameFr: 'Trépassable', nameEn: 'Palossand', slug: 'palossand', type: 'ghost', baseHp: 68, baseAtk: 16 },
          { nameFr: 'Rocabot', nameEn: 'Rockruff', slug: 'rockruff', type: 'rock', baseHp: 64, baseAtk: 15 },
          { nameFr: 'Bacabouh', nameEn: 'Sandygast', slug: 'sandygast', type: 'ghost', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Tadmorv (Alola)', nameEn: 'Grimer (Alola)', slug: 'grimer-alola', type: 'poison', baseHp: 65, baseAtk: 15 },
          { nameFr: 'Ossatueur (Alola)', nameEn: 'Marowak (Alola)', slug: 'marowak-alola', type: 'fire', baseHp: 65, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Paulie',
          nameEn: 'Hapu',
          slug: 'hapu',
          types: ['ground'],
          team: [
            { nameFr: 'Bourrinos', nameEn: 'Mudsdale', slug: 'mudsdale', level: 47 },
            { nameFr: 'Triopikeur (Alola)', nameEn: 'Dugtrio (Alola)', slug: 'dugtrio-alola', level: 48 },
            { nameFr: 'Trépassable', nameEn: 'Palossand', slug: 'palossand', level: 49 },
          ],
          timerSeconds: 35,
        },
      },
      {
        id: 12,
        nameFr: 'Conseil 4 — Kahili',
        nameEn: 'Elite Four — Kahili',
        types: ['flying', 'steel', 'ghost', 'rock'],
        wild: [
          { nameFr: 'Draïeul', nameEn: 'Drampa', slug: 'drampa', type: 'normal', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Denticrisse', nameEn: 'Bruxish', slug: 'bruxish', type: 'water', baseHp: 68, baseAtk: 16 },
          { nameFr: 'Bébécaille', nameEn: 'Jangmo-o', slug: 'jangmoo', type: 'dragon', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Quartermac', nameEn: 'Passimian', slug: 'passimian', type: 'fighting', baseHp: 68, baseAtk: 16 },
          { nameFr: 'Gouroutan', nameEn: 'Oranguru', slug: 'oranguru', type: 'normal', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Sovkipou', nameEn: 'Wimpod', slug: 'wimpod', type: 'bug', baseHp: 67, baseAtk: 16 },
          { nameFr: 'Boumata', nameEn: 'Turtonator', slug: 'turtonator', type: 'fire', baseHp: 68, baseAtk: 16 },
        ],
        boss: {
          nameFr: 'Kahili',
          nameEn: 'Kahili',
          slug: 'kahili',
          types: ['flying'],
          team: [
            { nameFr: 'Bazoucan', nameEn: 'Toucannon', slug: 'toucannon', level: 51 },
            { nameFr: 'Écaïd', nameEn: 'Hakamo-o', slug: 'hakamoo', level: 52 },
            { nameFr: 'Sarmuraï', nameEn: 'Golisopod', slug: 'golisopod', level: 53 },
            { nameFr: 'Prédastérie', nameEn: 'Toxapex', slug: 'toxapex', level: 54 },
          ],
          timerSeconds: 40,
        },
      },
      {
        id: 13,
        nameFr: 'Maître — Euphorbe',
        nameEn: 'Champion — Kukui',
        types: ['fire', 'water', 'grass', 'rock', 'steel'],
        wild: [
          { nameFr: 'Écaïd', nameEn: 'Hakamo-o', slug: 'hakamoo', type: 'dragon', baseHp: 74, baseAtk: 17 },
          { nameFr: 'Gouroutan', nameEn: 'Oranguru', slug: 'oranguru', type: 'normal', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Concombaffe', nameEn: 'Pyukumuku', slug: 'pyukumuku', type: 'water', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Dodoala', nameEn: 'Komala', slug: 'komala', type: 'normal', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Mimiqui', nameEn: 'Mimikyu', slug: 'mimikyu', type: 'ghost', baseHp: 74, baseAtk: 17 },
          { nameFr: 'Taupiqueur (Alola)', nameEn: 'Diglett (Alola)', slug: 'diglett-alola', type: 'ground', baseHp: 71, baseAtk: 16 },
          { nameFr: 'Mimantis', nameEn: 'Fomantis', slug: 'fomantis', type: 'grass', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Bébécaille', nameEn: 'Jangmo-o', slug: 'jangmoo', type: 'dragon', baseHp: 71, baseAtk: 16 },
        ],
        boss: {
          nameFr: 'Euphorbe',
          nameEn: 'Kukui',
          slug: 'kukui',
          types: ['fire'],
          team: [
            { nameFr: 'Lougaroc', nameEn: 'Lycanroc', slug: 'lycanroc', level: 55 },
            { nameFr: 'Ékaïser', nameEn: 'Kommo-o', slug: 'kommoo', level: 55 },
            { nameFr: 'Félinferno', nameEn: 'Incineroar', slug: 'incineroar', level: 56 },
            { nameFr: 'Oratoria', nameEn: 'Primarina', slug: 'primarina', level: 57 },
            { nameFr: 'Archéduc', nameEn: 'Decidueye', slug: 'decidueye', level: 58 },
            { nameFr: 'Solgaleo', nameEn: 'Solgaleo', slug: 'solgaleo', level: 60 },
          ],
          timerSeconds: 45,
        },
      },
    ],
  },
  // ══════════════════════════════════════════════════
  // Gen 8 — Galar
  // ══════════════════════════════════════════════════
  {
    id: 8,
    nameFr: 'Génération VIII',
    nameEn: 'Generation VIII',
    regionFr: 'Galar',
    regionEn: 'Galar',
    zones: [
      {
        id: 1,
        nameFr: 'Arène — Percy',
        nameEn: 'Gym — Milo',
        types: ['grass'],
        wild: [
          { nameFr: 'Tournicoton', nameEn: 'Gossifleur', slug: 'gossifleur', type: 'grass', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Moumouton', nameEn: 'Wooloo', slug: 'wooloo', type: 'normal', baseHp: 52, baseAtk: 10 },
          { nameFr: 'Rongourmand', nameEn: 'Skwovet', slug: 'skwovet', type: 'normal', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Minisange', nameEn: 'Rookidee', slug: 'rookidee', type: 'flying', baseHp: 48, baseAtk: 9 },
          { nameFr: 'Voltoutou', nameEn: 'Yamper', slug: 'yamper', type: 'electric', baseHp: 52, baseAtk: 10 },
          { nameFr: 'Larvadar', nameEn: 'Blipbug', slug: 'blipbug', type: 'bug', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Goupilou', nameEn: 'Nickit', slug: 'nickit', type: 'dark', baseHp: 51, baseAtk: 10 },
        ],
        boss: {
          nameFr: 'Percy',
          nameEn: 'Milo',
          slug: 'milo',
          types: ['grass'],
          team: [
            { nameFr: 'Blancoton', nameEn: 'Eldegoss', slug: 'eldegoss', level: 12 },
            { nameFr: 'Tournicoton', nameEn: 'Gossifleur', slug: 'gossifleur', level: 13 },
            { nameFr: 'Moumouflon', nameEn: 'Dubwool', slug: 'dubwool', level: 14 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 2,
        nameFr: 'Arène — Donna',
        nameEn: 'Gym — Nessa',
        types: ['water'],
        wild: [
          { nameFr: 'Khélocrok', nameEn: 'Chewtle', slug: 'chewtle', type: 'water', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Embrochet', nameEn: 'Arrokuda', slug: 'arrokuda', type: 'water', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Minisange', nameEn: 'Rookidee', slug: 'rookidee', type: 'flying', baseHp: 52, baseAtk: 10 },
          { nameFr: 'Tournicoton', nameEn: 'Gossifleur', slug: 'gossifleur', type: 'grass', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Voltoutou', nameEn: 'Yamper', slug: 'yamper', type: 'electric', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Rongourmand', nameEn: 'Skwovet', slug: 'skwovet', type: 'normal', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Larvadar', nameEn: 'Blipbug', slug: 'blipbug', type: 'bug', baseHp: 52, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Donna',
          nameEn: 'Nessa',
          slug: 'nessa',
          types: ['water'],
          team: [
            { nameFr: 'Torgamord', nameEn: 'Drednaw', slug: 'drednaw', level: 16 },
            { nameFr: 'Hastacuda', nameEn: 'Barraskewda', slug: 'barraskewda', level: 17 },
            { nameFr: 'Nigosier', nameEn: 'Cramorant', slug: 'cramorant', level: 18 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 3,
        nameFr: 'Arène — Kabu',
        nameEn: 'Gym — Kabu',
        types: ['fire'],
        wild: [
          { nameFr: 'Grillepattes', nameEn: 'Sizzlipede', slug: 'sizzlipede', type: 'fire', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Charbi', nameEn: 'Rolycoly', slug: 'rolycoly', type: 'rock', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Larvadar', nameEn: 'Blipbug', slug: 'blipbug', type: 'bug', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Moumouton', nameEn: 'Wooloo', slug: 'wooloo', type: 'normal', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Voltoutou', nameEn: 'Yamper', slug: 'yamper', type: 'electric', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Rongourmand', nameEn: 'Skwovet', slug: 'skwovet', type: 'normal', baseHp: 53, baseAtk: 11 },
          { nameFr: 'Minisange', nameEn: 'Rookidee', slug: 'rookidee', type: 'flying', baseHp: 53, baseAtk: 11 },
          { nameFr: 'Goupilou', nameEn: 'Nickit', slug: 'nickit', type: 'dark', baseHp: 54, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Kabu',
          nameEn: 'Kabu',
          slug: 'kabu',
          types: ['fire'],
          team: [
            { nameFr: 'Scolocendre', nameEn: 'Centiskorch', slug: 'centiskorch', level: 20 },
            { nameFr: 'Wagomine', nameEn: 'Carkol', slug: 'carkol', level: 21 },
            { nameFr: 'Monthracite', nameEn: 'Coalossal', slug: 'coalossal', level: 22 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 4,
        nameFr: 'Arène — Faïza',
        nameEn: 'Gym — Bea',
        types: ['fighting'],
        wild: [
          { nameFr: 'Poulpaf', nameEn: 'Clobbopus', slug: 'clobbopus', type: 'fighting', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Hexadron', nameEn: 'Falinks', slug: 'falinks', type: 'fighting', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Dunaja', nameEn: 'Silicobra', slug: 'silicobra', type: 'ground', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Toxizap', nameEn: 'Toxel', slug: 'toxel', type: 'electric', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Grimalin', nameEn: 'Impidimp', slug: 'impidimp', type: 'dark', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Nigosier', nameEn: 'Cramorant', slug: 'cramorant', type: 'flying', baseHp: 57, baseAtk: 12 },
          { nameFr: 'Zigzaton (Galar)', nameEn: 'Zigzagoon (Galar)', slug: 'zigzagoon-galar', type: 'dark', baseHp: 57, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Faïza',
          nameEn: 'Bea',
          slug: 'bea',
          types: ['fighting'],
          team: [
            { nameFr: 'Krakos', nameEn: 'Grapploct', slug: 'grapploct', level: 24 },
            { nameFr: 'Hexadron', nameEn: 'Falinks', slug: 'falinks', level: 25 },
            { nameFr: 'Dunaconda', nameEn: 'Sandaconda', slug: 'sandaconda', level: 26 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 5,
        nameFr: 'Arène — Sally',
        nameEn: 'Gym — Opal',
        types: ['fairy'],
        wild: [
          { nameFr: 'Bibichut', nameEn: 'Hatenna', slug: 'hatenna', type: 'psychic', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Grimalin', nameEn: 'Impidimp', slug: 'impidimp', type: 'dark', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Crèmy', nameEn: 'Milcery', slug: 'milcery', type: 'fairy', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Théffroi', nameEn: 'Sinistea', slug: 'sinistea', type: 'ghost', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Frissonille', nameEn: 'Snom', slug: 'snom', type: 'ice', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Tutafeh (Galar)', nameEn: 'Yamask (Galar)', slug: 'yamask-galar', type: 'ground', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Poulpaf', nameEn: 'Clobbopus', slug: 'clobbopus', type: 'fighting', baseHp: 56, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Sally',
          nameEn: 'Opal',
          slug: 'opal',
          types: ['fairy'],
          team: [
            { nameFr: 'Sorcilence', nameEn: 'Hatterene', slug: 'hatterene', level: 28 },
            { nameFr: 'Charmilly', nameEn: 'Alcremie', slug: 'alcremie', level: 29 },
            { nameFr: 'Angoliath', nameEn: 'Grimmsnarl', slug: 'grimmsnarl', level: 30 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 6,
        nameFr: 'Arène — Chaz',
        nameEn: 'Gym — Gordie',
        types: ['rock'],
        wild: [
          { nameFr: 'Dolman', nameEn: 'Stonjourner', slug: 'stonjourner', type: 'rock', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Charbi', nameEn: 'Rolycoly', slug: 'rolycoly', type: 'rock', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Dunaja', nameEn: 'Silicobra', slug: 'silicobra', type: 'ground', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Charibari', nameEn: 'Cufant', slug: 'cufant', type: 'steel', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Hexadron', nameEn: 'Falinks', slug: 'falinks', type: 'fighting', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Miaouss (Galar)', nameEn: 'Meowth (Galar)', slug: 'meowth-galar', type: 'steel', baseHp: 59, baseAtk: 13 },
          { nameFr: 'Duralugon', nameEn: 'Duraludon', slug: 'duraludon', type: 'steel', baseHp: 59, baseAtk: 13 },
          { nameFr: 'Galvagon', nameEn: 'Dracozolt', slug: 'dracozolt', type: 'electric', baseHp: 59, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Chaz',
          nameEn: 'Gordie',
          slug: 'gordie',
          types: ['rock'],
          team: [
            { nameFr: 'Monthracite', nameEn: 'Coalossal', slug: 'coalossal', level: 32 },
            { nameFr: 'Dolman', nameEn: 'Stonjourner', slug: 'stonjourner', level: 33 },
            { nameFr: 'Dunaconda', nameEn: 'Sandaconda', slug: 'sandaconda', level: 34 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 7,
        nameFr: 'Arène — Peterson',
        nameEn: 'Gym — Piers',
        types: ['dark'],
        wild: [
          { nameFr: 'Goupilou', nameEn: 'Nickit', slug: 'nickit', type: 'dark', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Morpeko', nameEn: 'Morpeko', slug: 'morpeko', type: 'electric', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Zigzaton (Galar)', nameEn: 'Zigzagoon (Galar)', slug: 'zigzagoon-galar', type: 'dark', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Grimalin', nameEn: 'Impidimp', slug: 'impidimp', type: 'dark', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Toxizap', nameEn: 'Toxel', slug: 'toxel', type: 'electric', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Limonde (Galar)', nameEn: 'Stunfisk (Galar)', slug: 'stunfisk-galar', type: 'ground', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Wimessir', nameEn: 'Indeedee', slug: 'indeedee', type: 'psychic', baseHp: 61, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Peterson',
          nameEn: 'Piers',
          slug: 'piers',
          types: ['dark'],
          team: [
            { nameFr: 'Roublenard', nameEn: 'Thievul', slug: 'thievul', level: 36 },
            { nameFr: 'Ixon', nameEn: 'Obstagoon', slug: 'obstagoon', level: 37 },
            { nameFr: 'Morpeko', nameEn: 'Morpeko', slug: 'morpeko', level: 38 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 8,
        nameFr: 'Arène — Roy',
        nameEn: 'Gym — Raihan',
        types: ['dragon'],
        wild: [
          { nameFr: 'Fantyrm', nameEn: 'Dreepy', slug: 'dreepy', type: 'dragon', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Verpom', nameEn: 'Applin', slug: 'applin', type: 'grass', baseHp: 62, baseAtk: 14 },
          { nameFr: 'Duralugon', nameEn: 'Duraludon', slug: 'duraludon', type: 'steel', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Frissonille', nameEn: 'Snom', slug: 'snom', type: 'ice', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Bibichut', nameEn: 'Hatenna', slug: 'hatenna', type: 'psychic', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Ouistempo', nameEn: 'Grookey', slug: 'grookey', type: 'grass', baseHp: 63, baseAtk: 14 },
          { nameFr: 'Ponyta (Galar)', nameEn: 'Ponyta (Galar)', slug: 'ponyta-galar', type: 'psychic', baseHp: 63, baseAtk: 14 },
        ],
        boss: {
          nameFr: 'Roy',
          nameEn: 'Raihan',
          slug: 'raihan',
          types: ['dragon'],
          team: [
            { nameFr: 'Duralugon', nameEn: 'Duraludon', slug: 'duraludon', level: 39 },
            { nameFr: 'Pomdrapi', nameEn: 'Flapple', slug: 'flapple', level: 40 },
            { nameFr: 'Dispareptil', nameEn: 'Drakloak', slug: 'drakloak', level: 41 },
            { nameFr: 'Dunaconda', nameEn: 'Sandaconda', slug: 'sandaconda', level: 42 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 9,
        nameFr: 'Coupe — Rosemary',
        nameEn: 'Cup — Marnie',
        types: ['dark'],
        wild: [
          { nameFr: 'Toxizap', nameEn: 'Toxel', slug: 'toxel', type: 'electric', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Frissonille', nameEn: 'Snom', slug: 'snom', type: 'ice', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Wimessir', nameEn: 'Indeedee', slug: 'indeedee', type: 'psychic', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Morpeko', nameEn: 'Morpeko', slug: 'morpeko', type: 'electric', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Bekaglaçon', nameEn: 'Eiscue', slug: 'eiscue', type: 'ice', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Flambino', nameEn: 'Scorbunny', slug: 'scorbunny', type: 'fire', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Wattapik', nameEn: 'Pincurchin', slug: 'pincurchin', type: 'electric', baseHp: 65, baseAtk: 14 },
          { nameFr: 'Hydragon', nameEn: 'Dracovish', slug: 'dracovish', type: 'water', baseHp: 65, baseAtk: 14 },
        ],
        boss: {
          nameFr: 'Rosemary',
          nameEn: 'Marnie',
          slug: 'marnie',
          types: ['dark'],
          team: [
            { nameFr: 'Morpeko', nameEn: 'Morpeko', slug: 'morpeko', level: 43 },
            { nameFr: 'Salarsen', nameEn: 'Toxtricity', slug: 'toxtricity', level: 44 },
            { nameFr: 'Angoliath', nameEn: 'Grimmsnarl', slug: 'grimmsnarl', level: 45 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 10,
        nameFr: 'Coupe — Travis',
        nameEn: 'Cup — Bede',
        types: ['fairy', 'psychic'],
        wild: [
          { nameFr: 'Ponyta (Galar)', nameEn: 'Ponyta (Galar)', slug: 'ponyta-galar', type: 'psychic', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Théffroi', nameEn: 'Sinistea', slug: 'sinistea', type: 'ghost', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Bekaglaçon', nameEn: 'Eiscue', slug: 'eiscue', type: 'ice', baseHp: 70, baseAtk: 15 },
          { nameFr: 'Bibichut', nameEn: 'Hatenna', slug: 'hatenna', type: 'psychic', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Crèmy', nameEn: 'Milcery', slug: 'milcery', type: 'fairy', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Larméléon', nameEn: 'Sobble', slug: 'sobble', type: 'water', baseHp: 67, baseAtk: 15 },
          { nameFr: 'Corayon (Galar)', nameEn: 'Corsola (Galar)', slug: 'corsola-galar', type: 'ghost', baseHp: 68, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Travis',
          nameEn: 'Bede',
          slug: 'bede',
          types: ['fairy', 'psychic'],
          team: [
            { nameFr: 'Sorcilence', nameEn: 'Hatterene', slug: 'hatterene', level: 46 },
            { nameFr: 'Galopa (Galar)', nameEn: 'Rapidash (Galar)', slug: 'rapidash-galar', level: 47 },
            { nameFr: 'Polthégeist', nameEn: 'Polteageist', slug: 'polteageist', level: 48 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 11,
        nameFr: 'Coupe — Nabil',
        nameEn: 'Cup — Hop',
        types: ['fighting', 'normal', 'flying'],
        wild: [
          { nameFr: 'Charibari', nameEn: 'Cufant', slug: 'cufant', type: 'steel', baseHp: 70, baseAtk: 15 },
          { nameFr: 'Limonde (Galar)', nameEn: 'Stunfisk (Galar)', slug: 'stunfisk-galar', type: 'ground', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Canarticho (Galar)', nameEn: "Farfetch'd (Galar)", slug: 'farfetchd-galar', type: 'fighting', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Moumouton', nameEn: 'Wooloo', slug: 'wooloo', type: 'normal', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Darumarond (Galar)', nameEn: 'Darumaka (Galar)', slug: 'darumaka-galar', type: 'ice', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Khélocrok', nameEn: 'Chewtle', slug: 'chewtle', type: 'water', baseHp: 67, baseAtk: 15 },
          { nameFr: 'Tutafeh (Galar)', nameEn: 'Yamask (Galar)', slug: 'yamask-galar', type: 'ground', baseHp: 68, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Nabil',
          nameEn: 'Hop',
          slug: 'hop',
          types: ['steel'],
          team: [
            { nameFr: 'Corvaillus', nameEn: 'Corviknight', slug: 'corviknight', level: 49 },
            { nameFr: 'Pachyradjah', nameEn: 'Copperajah', slug: 'copperajah', level: 50 },
            { nameFr: 'Palarticho', nameEn: "Sirfetch'd", slug: 'sirfetchd', level: 51 },
            { nameFr: 'Fulgudog', nameEn: 'Boltund', slug: 'boltund', level: 52 },
          ],
          timerSeconds: 35,
        },
      },
      {
        id: 12,
        nameFr: 'Macro Cosmos — Shehroz',
        nameEn: 'Macro Cosmos — Rose',
        types: ['dragon', 'poison'],
        wild: [
          { nameFr: 'Wattapik', nameEn: 'Pincurchin', slug: 'pincurchin', type: 'electric', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Corayon (Galar)', nameEn: 'Corsola (Galar)', slug: 'corsola-galar', type: 'ghost', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Darumarond (Galar)', nameEn: 'Darumaka (Galar)', slug: 'darumaka-galar', type: 'ice', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Fantyrm', nameEn: 'Dreepy', slug: 'dreepy', type: 'dragon', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Dolman', nameEn: 'Stonjourner', slug: 'stonjourner', type: 'rock', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Embrochet', nameEn: 'Arrokuda', slug: 'arrokuda', type: 'water', baseHp: 69, baseAtk: 16 },
          { nameFr: 'Dispareptil', nameEn: 'Drakloak', slug: 'drakloak', type: 'dragon', baseHp: 69, baseAtk: 16 },
          { nameFr: 'Miaouss (Galar)', nameEn: 'Meowth (Galar)', slug: 'meowth-galar', type: 'steel', baseHp: 69, baseAtk: 16 },
        ],
        boss: {
          nameFr: 'Shehroz',
          nameEn: 'Rose',
          slug: 'rose',
          types: ['dragon', 'poison'],
          team: [
            { nameFr: 'Pachyradjah', nameEn: 'Copperajah', slug: 'copperajah', level: 53 },
            { nameFr: 'Éthernatos', nameEn: 'Eternatus', slug: 'eternatus', level: 54 },
            { nameFr: 'Berserkatt', nameEn: 'Perrserker', slug: 'perrserker', level: 55 },
            { nameFr: 'Smogogo (Galar)', nameEn: 'Weezing (Galar)', slug: 'weezing-galar', level: 56 },
          ],
          timerSeconds: 40,
        },
      },
      {
        id: 13,
        nameFr: 'Maître — Tarak',
        nameEn: 'Champion — Leon',
        types: ['fire', 'water', 'grass', 'dragon', 'ghost'],
        wild: [
          { nameFr: 'Dispareptil', nameEn: 'Drakloak', slug: 'drakloak', type: 'dragon', baseHp: 76, baseAtk: 17 },
          { nameFr: 'Galvagon', nameEn: 'Dracozolt', slug: 'dracozolt', type: 'electric', baseHp: 74, baseAtk: 17 },
          { nameFr: 'Hydragon', nameEn: 'Dracovish', slug: 'dracovish', type: 'water', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Ouistempo', nameEn: 'Grookey', slug: 'grookey', type: 'grass', baseHp: 74, baseAtk: 17 },
          { nameFr: 'Verpom', nameEn: 'Applin', slug: 'applin', type: 'grass', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Grillepattes', nameEn: 'Sizzlipede', slug: 'sizzlipede', type: 'fire', baseHp: 72, baseAtk: 17 },
          { nameFr: 'Nigosier', nameEn: 'Cramorant', slug: 'cramorant', type: 'flying', baseHp: 73, baseAtk: 17 },
        ],
        boss: {
          nameFr: 'Tarak',
          nameEn: 'Leon',
          slug: 'leon',
          types: ['dragon'],
          team: [
            { nameFr: 'Corvaillus', nameEn: 'Corviknight', slug: 'corviknight', level: 55 },
            { nameFr: 'Lanssorien', nameEn: 'Dragapult', slug: 'dragapult', level: 56 },
            { nameFr: 'Gorythmic', nameEn: 'Rillaboom', slug: 'rillaboom', level: 57 },
            { nameFr: 'Pyrobut', nameEn: 'Cinderace', slug: 'cinderace', level: 58 },
            { nameFr: 'Lézargus', nameEn: 'Inteleon', slug: 'inteleon', level: 59 },
            { nameFr: 'Zacian', nameEn: 'Zacian', slug: 'zacian', level: 60 },
          ],
          timerSeconds: 45,
        },
      },
    ],
  },
  // ══════════════════════════════════════════════════
  // Gen 9 — Paldea
  // ══════════════════════════════════════════════════
  {
    id: 9,
    nameFr: 'Génération IX',
    nameEn: 'Generation IX',
    regionFr: 'Paldea',
    regionEn: 'Paldea',
    zones: [
      {
        id: 1,
        nameFr: 'Arène — Éra',
        nameEn: 'Gym — Katy',
        types: ['bug'],
        wild: [
          { nameFr: 'Tissenboule', nameEn: 'Tarountula', slug: 'tarountula', type: 'bug', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Lilliterelle', nameEn: 'Nymble', slug: 'nymble', type: 'bug', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Gourmelet', nameEn: 'Lechonk', slug: 'lechonk', type: 'normal', baseHp: 52, baseAtk: 10 },
          { nameFr: 'Pohm', nameEn: 'Pawmi', slug: 'pawmi', type: 'electric', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Pâtachiot', nameEn: 'Fidough', slug: 'fidough', type: 'fairy', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Compagnol', nameEn: 'Tandemaus', slug: 'tandemaus', type: 'normal', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Olivini', nameEn: 'Smoliv', slug: 'smoliv', type: 'grass', baseHp: 52, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Éra',
          nameEn: 'Katy',
          slug: 'katy',
          types: ['bug'],
          team: [
            { nameFr: 'Filentrappe', nameEn: 'Spidops', slug: 'spidops', level: 12 },
            { nameFr: 'Gambex', nameEn: 'Lokix', slug: 'lokix', level: 13 },
            { nameFr: 'Tissenboule', nameEn: 'Tarountula', slug: 'tarountula', level: 14 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 2,
        nameFr: 'Arène — Colza',
        nameEn: 'Gym — Brassius',
        types: ['grass'],
        wild: [
          { nameFr: 'Olivini', nameEn: 'Smoliv', slug: 'smoliv', type: 'grass', baseHp: 56, baseAtk: 11 },
          { nameFr: 'Pimito', nameEn: 'Capsakid', slug: 'capsakid', type: 'grass', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Pohm', nameEn: 'Pawmi', slug: 'pawmi', type: 'electric', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Gourmelet', nameEn: 'Lechonk', slug: 'lechonk', type: 'normal', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Lilliterelle', nameEn: 'Nymble', slug: 'nymble', type: 'bug', baseHp: 50, baseAtk: 10 },
          { nameFr: 'Tissenboule', nameEn: 'Tarountula', slug: 'tarountula', type: 'bug', baseHp: 53, baseAtk: 11 },
          { nameFr: 'Compagnol', nameEn: 'Tandemaus', slug: 'tandemaus', type: 'normal', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Pâtachiot', nameEn: 'Fidough', slug: 'fidough', type: 'fairy', baseHp: 52, baseAtk: 11 },
        ],
        boss: {
          nameFr: 'Colza',
          nameEn: 'Brassius',
          slug: 'brassius',
          types: ['grass'],
          team: [
            { nameFr: 'Olivado', nameEn: 'Dolliv', slug: 'dolliv', level: 16 },
            { nameFr: 'Scovilain', nameEn: 'Scovillain', slug: 'scovillain', level: 17 },
            { nameFr: 'Arboliva', nameEn: 'Arboliva', slug: 'arboliva', level: 18 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 3,
        nameFr: 'Arène — Mashynn',
        nameEn: 'Gym — Iono',
        types: ['electric'],
        wild: [
          { nameFr: 'Têtampoule', nameEn: 'Tadbulb', slug: 'tadbulb', type: 'electric', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Zapétrel', nameEn: 'Wattrel', slug: 'wattrel', type: 'electric', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Compagnol', nameEn: 'Tandemaus', slug: 'tandemaus', type: 'normal', baseHp: 54, baseAtk: 11 },
          { nameFr: 'Pohm', nameEn: 'Pawmi', slug: 'pawmi', type: 'electric', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Gribouraigne', nameEn: 'Shroodle', slug: 'shroodle', type: 'poison', baseHp: 52, baseAtk: 11 },
          { nameFr: 'Gourmelet', nameEn: 'Lechonk', slug: 'lechonk', type: 'normal', baseHp: 54, baseAtk: 12 },
          { nameFr: 'Tissenboule', nameEn: 'Tarountula', slug: 'tarountula', type: 'bug', baseHp: 54, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Mashynn',
          nameEn: 'Iono',
          slug: 'iono',
          types: ['electric'],
          team: [
            { nameFr: 'Ampibidou', nameEn: 'Bellibolt', slug: 'bellibolt', level: 20 },
            { nameFr: 'Fulgulairo', nameEn: 'Kilowattrel', slug: 'kilowattrel', level: 21 },
            { nameFr: 'Pohmotte', nameEn: 'Pawmo', slug: 'pawmo', level: 22 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 4,
        nameFr: 'Arène — Kombu',
        nameEn: 'Gym — Kofu',
        types: ['water'],
        wild: [
          { nameFr: 'Taupikeau', nameEn: 'Wiglett', slug: 'wiglett', type: 'water', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Dofin', nameEn: 'Finizen', slug: 'finizen', type: 'water', baseHp: 60, baseAtk: 12 },
          { nameFr: 'Virovent', nameEn: 'Bramblin', slug: 'bramblin', type: 'ghost', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Selutin', nameEn: 'Nacli', slug: 'nacli', type: 'rock', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Grondogue', nameEn: 'Maschiff', slug: 'maschiff', type: 'dark', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Toutombe', nameEn: 'Greavard', slug: 'greavard', type: 'ghost', baseHp: 57, baseAtk: 12 },
          { nameFr: 'Ferdeter', nameEn: 'Orthworm', slug: 'orthworm', type: 'steel', baseHp: 57, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Kombu',
          nameEn: 'Kofu',
          slug: 'kofu',
          types: ['water'],
          team: [
            { nameFr: 'Triopikeau', nameEn: 'Wugtrio', slug: 'wugtrio', level: 24 },
            { nameFr: 'Superdofin', nameEn: 'Palafin', slug: 'palafin', level: 25 },
            { nameFr: 'Oyacata', nameEn: 'Dondozo', slug: 'dondozo', level: 26 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 5,
        nameFr: 'Arène — Okuba',
        nameEn: 'Gym — Larry',
        types: ['normal'],
        wild: [
          { nameFr: 'Pâtachiot', nameEn: 'Fidough', slug: 'fidough', type: 'fairy', baseHp: 60, baseAtk: 12 },
          { nameFr: 'Grondogue', nameEn: 'Maschiff', slug: 'maschiff', type: 'dark', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Gribouraigne', nameEn: 'Shroodle', slug: 'shroodle', type: 'poison', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Vrombotor', nameEn: 'Revavroom', slug: 'revavroom', type: 'steel', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Flotillon', nameEn: 'Flittle', slug: 'flittle', type: 'psychic', baseHp: 56, baseAtk: 12 },
          { nameFr: 'Terracool', nameEn: 'Toedscool', slug: 'toedscool', type: 'ground', baseHp: 59, baseAtk: 12 },
          { nameFr: 'Oyacata', nameEn: 'Dondozo', slug: 'dondozo', type: 'water', baseHp: 58, baseAtk: 12 },
          { nameFr: 'Lilliterelle', nameEn: 'Nymble', slug: 'nymble', type: 'bug', baseHp: 58, baseAtk: 12 },
        ],
        boss: {
          nameFr: 'Okuba',
          nameEn: 'Larry',
          slug: 'larry',
          types: ['normal'],
          team: [
            { nameFr: 'Fragroin', nameEn: 'Oinkologne', slug: 'oinkologne', level: 28 },
            { nameFr: 'Briochien', nameEn: 'Dachsbun', slug: 'dachsbun', level: 29 },
            { nameFr: 'Famignol', nameEn: 'Maushold', slug: 'maushold', level: 30 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 6,
        nameFr: 'Arène — Laïm',
        nameEn: 'Gym — Ryme',
        types: ['ghost'],
        wild: [
          { nameFr: 'Toutombe', nameEn: 'Greavard', slug: 'greavard', type: 'ghost', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Terracool', nameEn: 'Toedscool', slug: 'toedscool', type: 'ground', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Germéclat', nameEn: 'Glimmet', slug: 'glimmet', type: 'rock', baseHp: 64, baseAtk: 13 },
          { nameFr: 'Virovent', nameEn: 'Bramblin', slug: 'bramblin', type: 'ghost', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Charbambin', nameEn: 'Charcadet', slug: 'charcadet', type: 'fire', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Léboulérou', nameEn: 'Rellor', slug: 'rellor', type: 'bug', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Poussacha', nameEn: 'Sprigatito', slug: 'sprigatito', type: 'grass', baseHp: 61, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Laïm',
          nameEn: 'Ryme',
          slug: 'ryme',
          types: ['ghost'],
          team: [
            { nameFr: 'Tomberro', nameEn: 'Houndstone', slug: 'houndstone', level: 32 },
            { nameFr: 'Virevorreur', nameEn: 'Brambleghast', slug: 'brambleghast', level: 33 },
            { nameFr: 'Floréclat', nameEn: 'Glimmora', slug: 'glimmora', level: 34 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 7,
        nameFr: 'Arène — Tully',
        nameEn: 'Gym — Tulip',
        types: ['psychic'],
        wild: [
          { nameFr: 'Flotillon', nameEn: 'Flittle', slug: 'flittle', type: 'psychic', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Léboulérou', nameEn: 'Rellor', slug: 'rellor', type: 'bug', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Charbambin', nameEn: 'Charcadet', slug: 'charcadet', type: 'fire', baseHp: 60, baseAtk: 13 },
          { nameFr: 'Selutin', nameEn: 'Nacli', slug: 'nacli', type: 'rock', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Forgerette', nameEn: 'Tinkatink', slug: 'tinkatink', type: 'fairy', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Germéclat', nameEn: 'Glimmet', slug: 'glimmet', type: 'rock', baseHp: 61, baseAtk: 13 },
          { nameFr: 'Chochodile', nameEn: 'Fuecoco', slug: 'fuecoco', type: 'fire', baseHp: 62, baseAtk: 13 },
        ],
        boss: {
          nameFr: 'Tully',
          nameEn: 'Tulip',
          slug: 'tulip',
          types: ['psychic'],
          team: [
            { nameFr: 'Cléopsytra', nameEn: 'Espathra', slug: 'espathra', level: 36 },
            { nameFr: 'Bérasca', nameEn: 'Rabsca', slug: 'rabsca', level: 37 },
            { nameFr: 'Carmadura', nameEn: 'Armarouge', slug: 'armarouge', level: 38 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 8,
        nameFr: 'Arène — Grusha',
        nameEn: 'Gym — Grusha',
        types: ['ice'],
        wild: [
          { nameFr: 'Piétacé', nameEn: 'Cetoddle', slug: 'cetoddle', type: 'ice', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Frigodo', nameEn: 'Frigibax', slug: 'frigibax', type: 'dragon', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Selutin', nameEn: 'Nacli', slug: 'nacli', type: 'rock', baseHp: 62, baseAtk: 13 },
          { nameFr: 'Flotillon', nameEn: 'Flittle', slug: 'flittle', type: 'psychic', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Vrombi', nameEn: 'Varoom', slug: 'varoom', type: 'steel', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Axoloto (Paldea)', nameEn: 'Wooper (Paldea)', slug: 'wooper-paldea', type: 'poison', baseHp: 63, baseAtk: 14 },
          { nameFr: 'Coiffeton', nameEn: 'Quaxly', slug: 'quaxly', type: 'water', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Nigirigon', nameEn: 'Tatsugiri', slug: 'tatsugiri', type: 'dragon', baseHp: 64, baseAtk: 14 },
        ],
        boss: {
          nameFr: 'Grusha',
          nameEn: 'Grusha',
          slug: 'grusha',
          types: ['ice'],
          team: [
            { nameFr: 'Balbalèze', nameEn: 'Cetitan', slug: 'cetitan', level: 39 },
            { nameFr: 'Cryodo', nameEn: 'Arctibax', slug: 'arctibax', level: 40 },
            { nameFr: 'Gigansel', nameEn: 'Garganacl', slug: 'garganacl', level: 41 },
            { nameFr: 'Glaivodo', nameEn: 'Baxcalibur', slug: 'baxcalibur', level: 42 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 9,
        nameFr: 'Conseil 4 — Cayenn',
        nameEn: 'E4 — Rika',
        types: ['ground'],
        wild: [
          { nameFr: 'Vrombi', nameEn: 'Varoom', slug: 'varoom', type: 'steel', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Forgerette', nameEn: 'Tinkatink', slug: 'tinkatink', type: 'fairy', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Mordudor', nameEn: 'Gimmighoul', slug: 'gimmighoul', type: 'ghost', baseHp: 64, baseAtk: 14 },
          { nameFr: 'Craparoi', nameEn: 'Klawf', slug: 'klawf', type: 'rock', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Dogrino', nameEn: 'Mabosstiff', slug: 'mabosstiff', type: 'dark', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Piétacé', nameEn: 'Cetoddle', slug: 'cetoddle', type: 'ice', baseHp: 65, baseAtk: 15 },
          { nameFr: 'Poltchageist', nameEn: 'Poltchageist', slug: 'poltchageist', type: 'ghost', baseHp: 65, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Cayenn',
          nameEn: 'Rika',
          slug: 'rika',
          types: ['ground'],
          team: [
            { nameFr: 'Terraiste', nameEn: 'Clodsire', slug: 'clodsire', level: 43 },
            { nameFr: 'Dunaconda', nameEn: 'Sandaconda', slug: 'sandaconda', level: 44 },
            { nameFr: 'Terracruel', nameEn: 'Toedscruel', slug: 'toedscruel', level: 45 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 10,
        nameFr: 'Conseil 4 — Popi',
        nameEn: 'E4 — Poppy',
        types: ['steel'],
        wild: [
          { nameFr: 'Axoloto (Paldea)', nameEn: 'Wooper (Paldea)', slug: 'wooper-paldea', type: 'poison', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Tauros (Paldea)', nameEn: 'Tauros (Paldea)', slug: 'tauros-paldea', type: 'fighting', baseHp: 70, baseAtk: 15 },
          { nameFr: 'Craparoi', nameEn: 'Klawf', slug: 'klawf', type: 'rock', baseHp: 66, baseAtk: 14 },
          { nameFr: 'Forgerette', nameEn: 'Tinkatink', slug: 'tinkatink', type: 'fairy', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Vrombi', nameEn: 'Varoom', slug: 'varoom', type: 'steel', baseHp: 70, baseAtk: 15 },
          { nameFr: 'Lestombaile', nameEn: 'Bombirdier', slug: 'bombirdier', type: 'flying', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Pimito', nameEn: 'Capsakid', slug: 'capsakid', type: 'grass', baseHp: 68, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Popi',
          nameEn: 'Poppy',
          slug: 'poppy',
          types: ['steel'],
          team: [
            { nameFr: 'Forgelina', nameEn: 'Tinkaton', slug: 'tinkaton', level: 46 },
            { nameFr: 'Pachyradjah', nameEn: 'Copperajah', slug: 'copperajah', level: 47 },
            { nameFr: 'Ferdeter', nameEn: 'Orthworm', slug: 'orthworm', level: 48 },
          ],
          timerSeconds: 30,
        },
      },
      {
        id: 11,
        nameFr: 'Conseil 4 — Okuba',
        nameEn: 'E4 — Larry',
        types: ['flying'],
        wild: [
          { nameFr: 'Lestombaile', nameEn: 'Bombirdier', slug: 'bombirdier', type: 'flying', baseHp: 70, baseAtk: 15 },
          { nameFr: 'Flamenroule', nameEn: 'Flamigo', slug: 'flamigo', type: 'flying', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Tapatoès', nameEn: 'Squawkabilly', slug: 'squawkabilly', type: 'normal', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Motorizard', nameEn: 'Cyclizar', slug: 'cyclizar', type: 'dragon', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Zapétrel', nameEn: 'Wattrel', slug: 'wattrel', type: 'electric', baseHp: 66, baseAtk: 15 },
          { nameFr: 'Tauros (Paldea)', nameEn: 'Tauros (Paldea)', slug: 'tauros-paldea', type: 'fighting', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Têtampoule', nameEn: 'Tadbulb', slug: 'tadbulb', type: 'electric', baseHp: 69, baseAtk: 15 },
          { nameFr: 'Délestin', nameEn: 'Veluza', slug: 'veluza', type: 'water', baseHp: 69, baseAtk: 15 },
        ],
        boss: {
          nameFr: 'Okuba',
          nameEn: 'Larry',
          slug: 'larry-e4',
          types: ['flying'],
          team: [
            { nameFr: 'Flamenroule', nameEn: 'Flamigo', slug: 'flamigo', level: 49 },
            { nameFr: 'Fulgulairo', nameEn: 'Kilowattrel', slug: 'kilowattrel', level: 50 },
            { nameFr: 'Lestombaile', nameEn: 'Bombirdier', slug: 'bombirdier', level: 51 },
            { nameFr: 'Tapatoès', nameEn: 'Squawkabilly', slug: 'squawkabilly', level: 52 },
          ],
          timerSeconds: 35,
        },
      },
      {
        id: 12,
        nameFr: 'Conseil 4 — Hassa',
        nameEn: 'E4 — Hassel',
        types: ['dragon'],
        wild: [
          { nameFr: 'Motorizard', nameEn: 'Cyclizar', slug: 'cyclizar', type: 'dragon', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Nigirigon', nameEn: 'Tatsugiri', slug: 'tatsugiri', type: 'dragon', baseHp: 74, baseAtk: 16 },
          { nameFr: 'Délestin', nameEn: 'Veluza', slug: 'veluza', type: 'water', baseHp: 70, baseAtk: 15 },
          { nameFr: 'Frigodo', nameEn: 'Frigibax', slug: 'frigibax', type: 'dragon', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Virovent', nameEn: 'Bramblin', slug: 'bramblin', type: 'ghost', baseHp: 68, baseAtk: 15 },
          { nameFr: 'Flamenroule', nameEn: 'Flamigo', slug: 'flamigo', type: 'flying', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Taupikeau', nameEn: 'Wiglett', slug: 'wiglett', type: 'water', baseHp: 71, baseAtk: 16 },
        ],
        boss: {
          nameFr: 'Hassa',
          nameEn: 'Hassel',
          slug: 'hassel',
          types: ['dragon'],
          team: [
            { nameFr: 'Glaivodo', nameEn: 'Baxcalibur', slug: 'baxcalibur', level: 53 },
            { nameFr: 'Motorizard', nameEn: 'Cyclizar', slug: 'cyclizar', level: 54 },
            { nameFr: 'Nigirigon', nameEn: 'Tatsugiri', slug: 'tatsugiri', level: 55 },
            { nameFr: 'Lanssorien', nameEn: 'Dragapult', slug: 'dragapult', level: 56 },
          ],
          timerSeconds: 40,
        },
      },
      {
        id: 13,
        nameFr: 'Maîtresse — Alisma',
        nameEn: 'Champion — Geeta',
        types: ['normal', 'dark', 'fighting', 'dragon', 'steel'],
        wild: [
          { nameFr: 'Vrombotor', nameEn: 'Revavroom', slug: 'revavroom', type: 'steel', baseHp: 76, baseAtk: 17 },
          { nameFr: 'Dogrino', nameEn: 'Mabosstiff', slug: 'mabosstiff', type: 'dark', baseHp: 74, baseAtk: 17 },
          { nameFr: 'Tag-Tag', nameEn: 'Grafaiai', slug: 'grafaiai', type: 'poison', baseHp: 72, baseAtk: 16 },
          { nameFr: 'Motorizard', nameEn: 'Cyclizar', slug: 'cyclizar', type: 'dragon', baseHp: 74, baseAtk: 17 },
          { nameFr: 'Mordudor', nameEn: 'Gimmighoul', slug: 'gimmighoul', type: 'ghost', baseHp: 70, baseAtk: 16 },
          { nameFr: 'Tapatoès', nameEn: 'Squawkabilly', slug: 'squawkabilly', type: 'normal', baseHp: 72, baseAtk: 17 },
          { nameFr: 'Dofin', nameEn: 'Finizen', slug: 'finizen', type: 'water', baseHp: 72, baseAtk: 17 },
        ],
        boss: {
          nameFr: 'Alisma',
          nameEn: 'Geeta',
          slug: 'geeta',
          types: ['fighting', 'dragon'],
          team: [
            { nameFr: 'Gromago', nameEn: 'Gholdengo', slug: 'gholdengo', level: 55 },
            { nameFr: 'Miascarade', nameEn: 'Meowscarada', slug: 'meowscarada', level: 56 },
            { nameFr: 'Flâmigator', nameEn: 'Skeledirge', slug: 'skeledirge', level: 57 },
            { nameFr: 'Palmaval', nameEn: 'Quaquaval', slug: 'quaquaval', level: 58 },
            { nameFr: 'Glaivodo', nameEn: 'Baxcalibur', slug: 'baxcalibur', level: 59 },
            { nameFr: 'Koraidon', nameEn: 'Koraidon', slug: 'koraidon', level: 60 },
          ],
          timerSeconds: 45,
        },
      },
    ],
  },
]

export function getGeneration(genId: number): Generation | undefined {
  return GENERATIONS.find((g) => g.id === genId)
}

export function getZone(genId: number, zoneId: number): Zone | undefined {
  return getGeneration(genId)?.zones.find((z) => z.id === zoneId)
}

export interface BossInfo {
  genId: number
  zoneId: number
  zoneFr: string
  zoneEn: string
  regionFr: string
  regionEn: string
  boss: BossTrainer
}

export function getAllBosses(): BossInfo[] {
  const bosses: BossInfo[] = []
  for (const gen of GENERATIONS) {
    for (const zone of gen.zones) {
      bosses.push({
        genId: gen.id,
        zoneId: zone.id,
        zoneFr: zone.nameFr,
        zoneEn: zone.nameEn,
        regionFr: gen.regionFr,
        regionEn: gen.regionEn,
        boss: zone.boss,
      })
    }
  }
  return bosses
}
